var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _polygon16, _polygon17, _polygon18, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _line, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _polygon19, _polygon20, _path443, _path444, _circle, _path445, _circle2, _path446, _path447, _path448, _circle3, _path449, _polygon21, _path450, _path451, _path452, _path453, _polygon22, _polygon23, _path454, _path455, _path456, _path457, _rect, _rect2, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _g, _rect3, _polygon24, _circle4, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebFigureMotiv1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.82 274.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.79,202.86l.06,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.55.55,0,0,0,.34-.46L401,202.86a.56.56,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,398.79,202.86Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 201.06,
    cy: 193.25,
    r: 10.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 601.48, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d52027"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.34,194.56l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.47l-.05-24.54a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,383.34,194.56Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 216.52,
    cy: 184.95,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,185.27l.05,24.54a.58.58,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,368,185.27Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 231.83,
    cy: 175.66,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.27,175.93l.06,24.54a.57.57,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.47l-.05-24.54a.59.59,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,351.27,175.93Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 248.58,
    cy: 166.32,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337,167.52l.06,24.54a.56.56,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.47l-.06-24.53a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,337,167.52Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 262.81,
    cy: 157.91,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.37,159.11l.06,24.54a.57.57,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.58.58,0,0,0,.32-.47l-.05-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,322.37,159.11Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 277.48,
    cy: 149.5,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.54,216.1l0,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.58.58,0,0,1,375.54,216.1Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 224.32,
    cy: 206.49,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.07,207.79l.06,24.55a.55.55,0,0,0,.32.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.06-24.54a.55.55,0,0,1-.32.46,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,360.07,207.79Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 239.78,
    cy: 198.18,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.76,198.51l.05,24.54a.59.59,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46L347,198.5a.55.55,0,0,1-.32.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,344.76,198.51Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 255.09,
    cy: 188.9,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,189.16l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.05-24.54a.57.57,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.56.56,0,0,1,328,189.16Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 271.84,
    cy: 179.55,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.79,180.75l0,24.55a.55.55,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.32-.46L316,180.75a.56.56,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.57.57,0,0,1,313.79,180.75Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 286.07,
    cy: 171.14,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.11,172.34l.06,24.54a.57.57,0,0,0,.32.46,1.75,1.75,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,299.11,172.34Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 300.74,
    cy: 162.73,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.94,228.21l.06,24.53a.55.55,0,0,0,.32.46,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.05-24.54a.56.56,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,354.94,228.21Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 244.91,
    cy: 218.6,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.48,219.9l.06,24.54a.53.53,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l0-24.54a.59.59,0,0,1-.34.46,1.76,1.76,0,0,1-1.58,0A.56.56,0,0,1,339.48,219.9Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 260.37,
    cy: 210.29,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.17,210.62l.05,24.53a.56.56,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.46l-.06-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.57.57,0,0,1,324.17,210.62Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 275.68,
    cy: 201,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.42,201.27l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.57.57,0,0,1-.33.47,1.76,1.76,0,0,1-1.58,0A.57.57,0,0,1,307.42,201.27Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 292.43,
    cy: 191.66,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.19,192.86l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.54a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,293.19,192.86Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 306.66,
    cy: 183.25,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.52,184.45l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.55.55,0,0,1-.33.46,1.7,1.7,0,0,1-1.58,0A.55.55,0,0,1,278.52,184.45Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 321.33,
    cy: 174.84,
    r: 10.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.77,242.1l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.46L333,242.1a.55.55,0,0,1-.33.46,1.76,1.76,0,0,1-1.58,0A.56.56,0,0,1,330.77,242.1Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 269.08,
    cy: 232.49,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.31,233.8l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.34-.46l-.06-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.58.58,0,0,1,315.31,233.8Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 284.55,
    cy: 224.19,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,224.51l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.59.59,0,0,0,.34-.46l-.06-24.54a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.57.57,0,0,1,300,224.51Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 299.85,
    cy: 214.9,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.25,215.17l.05,24.54a.59.59,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,283.25,215.17Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 316.61,
    cy: 205.56,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,206.76l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.58.58,0,0,1-.32.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,269,206.76Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 330.83,
    cy: 197.15,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.35,198.35l.05,24.54a.55.55,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.06-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,254.35,198.35Z",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 345.51,
    cy: 188.74,
    r: 10.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(0 -13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "84.81 160.06 85.41 157.9 87.14 158.22 86.54 160.39 84.81 160.06",
    fill: "none"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "422.47 210.33 328.63 264.87 234.18 210.33 328.02 155.8 422.47 210.33",
    fill: "#68442e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "342.2 257.11 335.49 260.93 241.04 206.4 247.75 202.58 342.2 257.11",
    fill: "#905e3f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "342.94 256.62 336.22 260.44 241.77 205.9 248.48 202.08 342.94 256.62",
    fill: "#432c1d"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.39 254.71 343.03 256.62 248.58 202.08 251.93 200.18 346.39 254.71",
    fill: "#2e1f15"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "328.63 264.87 328.62 273.62 234.17 219.09 234.18 210.33 328.63 264.87",
    fill: "#3b261b"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.47 210.33 422.46 219.09 328.62 273.62 328.63 264.87 422.47 210.33",
    fill: "#503424"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.49 243.1 359.78 246.91 265.32 192.39 272.03 188.57 366.49 243.1",
    fill: "#905e3f"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.22 242.6 360.51 246.42 266.06 191.89 272.77 188.07 367.22 242.6",
    fill: "#432c1d"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.68 240.69 367.32 242.6 272.87 188.07 276.22 186.16 370.68 240.69",
    fill: "#2e1f15"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.16 230.83 380.45 234.65 286 180.12 292.71 176.3 387.16 230.83",
    fill: "#905e3f"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.89 230.33 381.18 234.15 286.73 179.62 293.44 175.8 387.89 230.33",
    fill: "#432c1d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.35 228.42 387.99 230.33 293.54 175.8 296.89 173.89 391.35 228.42",
    fill: "#2e1f15"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.2 218.25 402.49 222.07 308.04 167.54 314.75 163.72 409.2 218.25",
    fill: "#905e3f"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.94 217.75 403.22 221.57 308.77 167.04 315.48 163.22 409.94 217.75",
    fill: "#432c1d"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.39 215.84 410.03 217.75 315.58 163.22 318.94 161.31 413.39 215.84",
    fill: "#2e1f15"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.91,205.17l-1.06-.61a.36.36,0,0,0-.25-.06.91.91,0,0,0-.35.12l1.06.62a.91.91,0,0,1,.35-.12.42.42,0,0,1,.25,0Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.31,205.24l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.69,7.57l1.06.62c-.8-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.31,205.24c-1.13.65-2.85,3.91-4.07,7.78-1.33,4.28-1.53,7.7-.43,7.62a.64.64,0,0,0,.34-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.28,1.54-7.7.44-7.62A.91.91,0,0,0,405.31,205.24Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.13,209.17l-1.06-.62a1.12,1.12,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395,209.07l-1.06-.62a1.3,1.3,0,0,0-.2.15c-1.09,1-.95,4.67.32,8.13.83,2.27,1.94,3.89,2.91,4.46l1.06.62c-1-.57-2.08-2.2-2.91-4.46-1.27-3.47-1.41-7.1-.32-8.13a1.3,1.3,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M395,209.07a1.3,1.3,0,0,0-.2.15c-1.09,1-.95,4.66.32,8.13,1.19,3.26,3,5.2,4.08,4.55a.66.66,0,0,0,.2-.14c1.1-1,.95-4.67-.31-8.13C397.85,210.36,396.08,208.42,395,209.07Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M398.79,202.86l.06,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.55.55,0,0,0,.34-.46L401,202.86a.56.56,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,398.79,202.86Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M398.79,202.86l.06,24.54a.56.56,0,0,0,.33.46l.16.08,0-24.54-.17-.08a.59.59,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M399.29,203.4l0,24.54a1.59,1.59,0,0,0,.39.1l-.06-24.55a1.24,1.24,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M399.67,203.49l.06,24.55a1.77,1.77,0,0,0,1-.18l.07,0-.06-24.54-.06,0a1.71,1.71,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M400.77,203.28l.06,24.54a.7.7,0,0,0,.21-.21L401,203.07a.6.6,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M401,203.07l.06,24.54a.42.42,0,0,0,.06-.21L401,202.86a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M399.13,202.4c-.44.26-.44.67,0,.92a1.78,1.78,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.78,1.78,0,0,0,399.13,202.4Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M395.12,197.25c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S395.12,192,395.12,197.25Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M395.12,197.25c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S395.12,192,395.12,197.25Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M390.45,196.87l-1.06-.61a.36.36,0,0,0-.25-.06.86.86,0,0,0-.35.12l1.06.62a.67.67,0,0,1,.34-.12.44.44,0,0,1,.26.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M389.85,196.94l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.69,7.57l1.06.62c-.8-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M389.85,196.94c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.53,7.7-.44,7.62a.86.86,0,0,0,.35-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.29,1.54-7.7.43-7.62A.67.67,0,0,0,389.85,196.94Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M380.67,200.86l-1.06-.61a1.12,1.12,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5,200.77l-1.06-.62a1,1,0,0,0-.2.15c-1.1,1-.95,4.66.31,8.13.84,2.26,1.95,3.89,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.92-4.46-1.27-3.47-1.41-7.11-.31-8.14a.9.9,0,0,1,.2-.14Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5,200.77a.9.9,0,0,0-.2.14c-1.1,1-1,4.67.31,8.14,1.2,3.26,3,5.2,4.09,4.55a1.3,1.3,0,0,0,.2-.15c1.1-1,1-4.66-.31-8.13C382.39,202.06,380.62,200.12,379.5,200.77Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M383.34,194.56l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.47l-.05-24.54a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,383.34,194.56Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M383.34,194.56l.05,24.54a.56.56,0,0,0,.33.46l.16.08-.05-24.54-.17-.08a.55.55,0,0,1-.32-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M383.83,195.1l.05,24.54a1.24,1.24,0,0,0,.38.09l-.05-24.54a1.51,1.51,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M384.21,195.19l.05,24.54a1.72,1.72,0,0,0,1-.17l.06,0L385.31,195l-.06,0a1.72,1.72,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M385.31,195l.05,24.54a.7.7,0,0,0,.21-.21l-.05-24.55a.73.73,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M385.52,194.76l.05,24.55a.43.43,0,0,0,.06-.22l-.05-24.54a.37.37,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M383.66,194.1c-.44.25-.44.66,0,.92a1.78,1.78,0,0,0,1.59,0c.44-.26.44-.67,0-.92A1.78,1.78,0,0,0,383.66,194.1Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.66,189c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S379.66,183.64,379.66,189Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M379.66,189c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S379.66,183.64,379.66,189Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M375.14,187.58l-1.06-.61a.46.46,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.73.73,0,0,1,.35-.12.42.42,0,0,1,.25.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M374.54,187.65l-1.06-.62c-1.14.65-2.86,3.91-4.07,7.78s-1.5,7.1-.69,7.57l1.06.62c-.81-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M374.54,187.65c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.54,7.7-.44,7.62a1,1,0,0,0,.35-.11c1.13-.66,2.86-3.92,4.07-7.79,1.34-4.29,1.54-7.7.44-7.62A.73.73,0,0,0,374.54,187.65Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M365.36,191.57,364.3,191a1.14,1.14,0,0,0-1.18-.1l1.07.62a1.14,1.14,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19,191.48l-1.07-.62a1.25,1.25,0,0,0-.19.15c-1.1,1-1,4.67.31,8.13.84,2.27,1.95,3.89,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.92-4.46-1.26-3.46-1.41-7.11-.31-8.13a.7.7,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19,191.48a.7.7,0,0,0-.2.15c-1.1,1-.95,4.67.31,8.13,1.2,3.26,3,5.2,4.09,4.55a1.3,1.3,0,0,0,.2-.15c1.09-1,1-4.66-.32-8.13C367.08,192.77,365.3,190.83,364.19,191.48Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M368,185.27l.05,24.54a.58.58,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,368,185.27Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M368,185.27l.05,24.54a.58.58,0,0,0,.33.46l.17.08-.05-24.54-.17-.08a.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M368.52,185.81l.05,24.54a1.62,1.62,0,0,0,.38.09l-.05-24.54a1.12,1.12,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M368.9,185.9l.05,24.54a1.72,1.72,0,0,0,1-.17l.06,0L370,185.69l-.05,0a1.73,1.73,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370,185.69l.06,24.54a.84.84,0,0,0,.21-.21l-.05-24.54a.64.64,0,0,1-.22.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M370.21,185.48l.05,24.54a.42.42,0,0,0,.06-.21l-.05-24.55a.43.43,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M368.35,184.81c-.44.25-.44.66,0,.92a1.78,1.78,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.78,1.78,0,0,0,368.35,184.81Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M364.35,179.66c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S364.35,174.35,364.35,179.66Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M364.35,179.66c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S364.35,174.35,364.35,179.66Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4,178.24l-1.07-.62a.51.51,0,0,0-.25-.06,1,1,0,0,0-.35.12l1.06.62a.91.91,0,0,1,.35-.12.58.58,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M357.79,178.3l-1.06-.62c-1.13.66-2.86,3.92-4.07,7.78s-1.5,7.11-.7,7.58l1.07.61c-.8-.47-.54-3.65.69-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M357.79,178.3c-1.13.66-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a.86.86,0,0,0,.35-.12c1.13-.66,2.86-3.91,4.07-7.78,1.34-4.29,1.53-7.7.44-7.63A.91.91,0,0,0,357.79,178.3Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61,182.23l-1.06-.62a1.12,1.12,0,0,0-1.17-.09l1.06.61a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M347.44,182.13l-1.06-.61a1.3,1.3,0,0,0-.2.15c-1.1,1-1,4.66.31,8.12.84,2.27,1.94,3.9,2.92,4.47l1.06.62c-1-.57-2.09-2.2-2.91-4.47-1.28-3.46-1.42-7.1-.32-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M347.44,182.13a1,1,0,0,0-.2.15c-1.1,1-1,4.67.32,8.13,1.19,3.26,3,5.2,4.08,4.56a1,1,0,0,0,.2-.15c1.1-1,1-4.67-.31-8.13C350.33,183.43,348.56,181.49,347.44,182.13Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M351.27,175.93l.06,24.54a.57.57,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.47l-.05-24.54a.59.59,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,351.27,175.93Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M351.27,175.93l.06,24.54a.57.57,0,0,0,.33.46l.16.08-.05-24.55-.17-.07a.59.59,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M351.77,176.46l.05,24.55a2.34,2.34,0,0,0,.38.09l-.05-24.54a1.41,1.41,0,0,1-.38-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M352.15,176.56l.05,24.54a1.71,1.71,0,0,0,1-.17l.06,0-.05-24.54-.06,0a1.72,1.72,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M353.25,176.35l.05,24.54a.69.69,0,0,0,.21-.21l-.05-24.55a.86.86,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M353.46,176.13l.05,24.55a.46.46,0,0,0,.06-.22l-.05-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6,175.46a.49.49,0,0,0,0,.93,1.78,1.78,0,0,0,1.59,0,.49.49,0,0,0,0-.93A1.78,1.78,0,0,0,351.6,175.46Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M347.6,170.32c0,5.31,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S347.6,165,347.6,170.32Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M347.6,170.32c0,5.31,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S347.6,165,347.6,170.32Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16,169.83l-1.06-.61a.36.36,0,0,0-.25-.06.86.86,0,0,0-.35.12l1.06.61a.74.74,0,0,1,.35-.11.42.42,0,0,1,.25.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M343.56,169.89l-1.06-.61c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.69,7.57l1.06.61c-.8-.46-.53-3.65.69-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M343.56,169.89c-1.13.66-2.86,3.92-4.07,7.78-1.34,4.29-1.53,7.71-.43,7.63a.87.87,0,0,0,.34-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.29,1.54-7.7.44-7.62A.74.74,0,0,0,343.56,169.89Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M334.38,173.82l-1.06-.62a1.14,1.14,0,0,0-1.17-.09l1.06.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M333.21,173.73l-1.06-.62a1.3,1.3,0,0,0-.2.15c-1.09,1-.95,4.66.31,8.13.84,2.26,1.95,3.89,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.92-4.47-1.26-3.46-1.4-7.1-.31-8.13l.2-.14Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M333.21,173.73l-.2.14c-1.09,1-.95,4.67.31,8.13,1.2,3.26,3,5.21,4.09,4.56a1.37,1.37,0,0,0,.21-.15c1.09-1,.95-4.67-.32-8.13C336.1,175,334.33,173.08,333.21,173.73Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M337,167.52l.06,24.54a.56.56,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.47l-.06-24.53a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.59.59,0,0,1,337,167.52Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M337,167.52l.06,24.54a.56.56,0,0,0,.33.46l.16.08,0-24.54-.17-.08a.59.59,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M337.54,168.06l0,24.54a2.23,2.23,0,0,0,.39.09l-.06-24.54a2.34,2.34,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M337.92,168.15l.06,24.54a1.73,1.73,0,0,0,1-.17.09.09,0,0,1,.06,0L339,167.94l-.06,0a1.72,1.72,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M339,167.94l.06,24.54a.7.7,0,0,0,.21-.21l-.06-24.54a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M339.23,167.73l.06,24.54a.46.46,0,0,0,.06-.22l-.06-24.53a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M337.38,167.06a.49.49,0,0,0,0,.92,1.78,1.78,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.7,1.7,0,0,0,337.38,167.06Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M333.37,161.91c0,5.31,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S333.37,156.6,333.37,161.91Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M333.37,161.91c0,5.31,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S333.37,156.6,333.37,161.91Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5,161.42l-1.06-.62a.58.58,0,0,0-.26-.06.91.91,0,0,0-.35.12l1.06.62a.91.91,0,0,1,.35-.12.55.55,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M328.89,161.48l-1.06-.62c-1.13.66-2.86,3.92-4.07,7.78s-1.49,7.11-.69,7.58l1.06.61c-.8-.46-.53-3.65.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M328.89,161.48c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.29-1.53,7.7-.43,7.63a.87.87,0,0,0,.34-.12c1.14-.66,2.86-3.91,4.07-7.78,1.34-4.29,1.53-7.7.44-7.63A.91.91,0,0,0,328.89,161.48Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M319.71,165.41l-1.06-.62a1.12,1.12,0,0,0-1.17-.09l1.06.61a1.14,1.14,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.54,165.31l-1.06-.61a1.21,1.21,0,0,0-.2.14c-1.1,1-1,4.67.32,8.13.82,2.27,1.93,3.9,2.91,4.47l1.06.61c-1-.57-2.08-2.19-2.91-4.46-1.28-3.46-1.42-7.1-.32-8.13.07-.05.13-.11.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M318.54,165.31c-.07,0-.13.1-.2.15-1.1,1-1,4.67.32,8.13,1.19,3.26,3,5.2,4.08,4.56a1,1,0,0,0,.2-.15c1.1-1,1-4.67-.31-8.13C321.43,166.61,319.66,164.67,318.54,165.31Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M322.37,159.11l.06,24.54a.57.57,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.58.58,0,0,0,.32-.47l-.05-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,322.37,159.11Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M322.37,159.11l.06,24.54a.57.57,0,0,0,.33.46l.16.07-.05-24.54a.65.65,0,0,1-.17-.08.55.55,0,0,1-.33-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M322.87,159.64l.05,24.54a1.59,1.59,0,0,0,.39.1l-.06-24.54a1.64,1.64,0,0,1-.38-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M323.25,159.74l.06,24.54a1.73,1.73,0,0,0,1-.17s0,0,0,0l0-24.54-.06,0a1.65,1.65,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M324.35,159.53l0,24.54a.69.69,0,0,0,.21-.21l-.05-24.55a.86.86,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M324.56,159.31l.05,24.55a.46.46,0,0,0,.06-.22l-.05-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M322.71,158.64c-.44.26-.45.67,0,.92a1.72,1.72,0,0,0,1.59,0c.44-.25.44-.66,0-.92A1.76,1.76,0,0,0,322.71,158.64Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M318.7,153.5c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S318.7,148.19,318.7,153.5Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M318.7,153.5c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S318.7,148.19,318.7,153.5Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M382.66,218.41l-1.07-.62a.42.42,0,0,0-.25,0,.74.74,0,0,0-.35.11l1.06.62a.91.91,0,0,1,.35-.12.48.48,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M382.05,218.47l-1.06-.62c-1.13.66-2.86,3.92-4.07,7.78s-1.49,7.11-.69,7.57l1.06.62c-.8-.46-.53-3.65.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M382.05,218.47c-1.13.65-2.85,3.91-4.07,7.78-1.34,4.29-1.53,7.7-.44,7.63a.81.81,0,0,0,.35-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.29,1.54-7.7.44-7.63A.91.91,0,0,0,382.05,218.47Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M372.87,222.4l-1.06-.62a1.12,1.12,0,0,0-1.17-.09l1.06.61a1.14,1.14,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M371.7,222.3l-1.06-.61-.2.14c-1.1,1-.95,4.67.31,8.14.84,2.26,1.95,3.89,2.92,4.46l1.06.61c-1-.56-2.08-2.19-2.92-4.46-1.26-3.46-1.41-7.1-.31-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M371.7,222.3a1,1,0,0,0-.2.15c-1.1,1-.95,4.67.31,8.13,1.21,3.27,3,5.21,4.1,4.56a1.25,1.25,0,0,0,.19-.15c1.1-1,1-4.66-.31-8.13C374.59,223.6,372.82,221.66,371.7,222.3Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M375.54,216.1l0,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.58.58,0,0,1,375.54,216.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M375.54,216.1l0,24.54a.56.56,0,0,0,.33.46l.16.07L376,216.64l-.17-.08a.58.58,0,0,1-.32-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M376,216.64l.05,24.53a1.59,1.59,0,0,0,.39.1l-.06-24.54a2.34,2.34,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M376.41,216.73l.06,24.54a1.69,1.69,0,0,0,1-.17l.06,0-.05-24.54-.06,0a1.72,1.72,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M377.51,216.52l.05,24.54a.6.6,0,0,0,.21-.21l0-24.54a1,1,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M377.72,216.31l0,24.54a.34.34,0,0,0,.06-.21l-.05-24.55a.46.46,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M375.87,215.64c-.45.25-.45.66,0,.92a1.78,1.78,0,0,0,1.59,0c.44-.26.44-.67,0-.92A1.7,1.7,0,0,0,375.87,215.64Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M371.86,210.49c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S371.86,205.18,371.86,210.49Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M371.86,210.49c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S371.86,205.18,371.86,210.49Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M367.19,210.11l-1.06-.62a.54.54,0,0,0-.25-.06.81.81,0,0,0-.35.12l1.06.62a.86.86,0,0,1,.35-.12.36.36,0,0,1,.25.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M366.59,210.17l-1.06-.62c-1.13.66-2.86,3.91-4.07,7.78s-1.49,7.11-.69,7.57l1.06.62c-.8-.47-.53-3.65.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M366.59,210.17c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a.91.91,0,0,0,.35-.12c1.13-.66,2.86-3.91,4.07-7.78,1.34-4.29,1.53-7.71.44-7.63A.86.86,0,0,0,366.59,210.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M357.41,214.1l-1.06-.62a1.14,1.14,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M356.24,214l-1.06-.62a1,1,0,0,0-.2.15c-1.1,1-1,4.67.31,8.13.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.56-2.09-2.19-2.91-4.46-1.28-3.46-1.42-7.1-.32-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M356.24,214a1,1,0,0,0-.2.15c-1.1,1-1,4.67.32,8.13,1.19,3.26,3,5.2,4.08,4.56a1,1,0,0,0,.2-.15c1.1-1,.95-4.67-.32-8.13C359.13,215.3,357.36,213.36,356.24,214Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M360.07,207.79l.06,24.55a.55.55,0,0,0,.32.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.06-24.54a.55.55,0,0,1-.32.46,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,360.07,207.79Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M360.07,207.79l.06,24.55a.55.55,0,0,0,.32.45l.17.08-.06-24.54-.16-.08a.55.55,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M360.56,208.33l.06,24.54a1.64,1.64,0,0,0,.38.1L361,208.43a1.59,1.59,0,0,1-.39-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M361,208.43,361,233a1.71,1.71,0,0,0,1-.18l.06,0-.05-24.54-.06,0a1.81,1.81,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M362.05,208.21l.05,24.54a.53.53,0,0,0,.21-.21L362.25,208a.57.57,0,0,1-.2.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25,208l.06,24.54a.39.39,0,0,0,.06-.21l-.06-24.54a.34.34,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M360.4,207.33c-.44.26-.44.67,0,.92a1.78,1.78,0,0,0,1.59,0c.44-.25.44-.66,0-.92A1.78,1.78,0,0,0,360.4,207.33Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M356.4,202.19c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S356.4,196.88,356.4,202.19Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M356.4,202.19c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S356.4,196.88,356.4,202.19Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M351.88,200.82l-1.06-.62a.45.45,0,0,0-.26,0,.64.64,0,0,0-.34.12l1.06.61a.81.81,0,0,1,.35-.12.44.44,0,0,1,.25.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M351.28,200.88l-1.06-.61c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.7,7.57l1.06.61c-.79-.47-.52-3.65.7-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M351.28,200.88c-1.13.66-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.62a.74.74,0,0,0,.35-.11c1.13-.66,2.85-3.91,4.07-7.78,1.34-4.29,1.53-7.7.44-7.63A.81.81,0,0,0,351.28,200.88Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M342.1,204.81l-1.06-.62a1.12,1.12,0,0,0-1.17-.09l1.06.61a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M340.93,204.71l-1.06-.61a.7.7,0,0,0-.2.15c-1.1,1-1,4.66.31,8.13.83,2.26,1.94,3.89,2.92,4.45l1.06.63c-1-.57-2.08-2.2-2.92-4.47-1.27-3.46-1.41-7.1-.31-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M340.93,204.71a1,1,0,0,0-.2.15c-1.1,1-1,4.67.31,8.13,1.2,3.26,3,5.2,4.09,4.56a1,1,0,0,0,.2-.15c1.1-1,.95-4.67-.32-8.13C343.81,206,342.05,204.07,340.93,204.71Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M344.76,198.51l.05,24.54a.59.59,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46L347,198.5a.55.55,0,0,1-.32.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,344.76,198.51Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M344.76,198.51l.05,24.54a.59.59,0,0,0,.33.45l.17.09L345.26,199a.67.67,0,0,1-.17-.08.55.55,0,0,1-.33-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M345.26,199l.05,24.55a2.34,2.34,0,0,0,.38.09l-.05-24.54a1.51,1.51,0,0,1-.38-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M345.64,199.14l.05,24.54a1.65,1.65,0,0,0,1-.18l.06,0-.06-24.54-.05,0a1.65,1.65,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M346.73,198.93l.06,24.54a.69.69,0,0,0,.21-.21l-.06-24.55a.62.62,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M346.94,198.71l.06,24.55a.46.46,0,0,0,.06-.22L347,198.5a.34.34,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M345.09,198c-.43.26-.44.67,0,.92a1.72,1.72,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.78,1.78,0,0,0,345.09,198Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M341.08,192.9c0,5.31,2.17,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S341.08,187.59,341.08,192.9Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M341.08,192.9c0,5.31,2.17,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S341.08,187.59,341.08,192.9Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M335.14,191.47l-1.07-.61a.36.36,0,0,0-.25-.06.86.86,0,0,0-.35.12l1.06.62a.86.86,0,0,1,.35-.12.47.47,0,0,1,.26.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53,191.54l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.69,7.57l1.06.62c-.8-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M334.53,191.54c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.54,7.7-.43,7.62a.87.87,0,0,0,.34-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.28,1.53-7.7.44-7.62A.86.86,0,0,0,334.53,191.54Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M325.35,195.46l-1.06-.61a1.12,1.12,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M324.18,195.37l-1.06-.62a1,1,0,0,0-.2.15c-1.1,1-.95,4.67.31,8.13.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.91-4.46-1.27-3.47-1.42-7.11-.32-8.13a.7.7,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M324.18,195.37a.7.7,0,0,0-.2.15c-1.1,1-1,4.66.32,8.13,1.19,3.26,3,5.2,4.08,4.55a.9.9,0,0,0,.2-.14c1.09-1,1-4.67-.31-8.14C327.07,196.66,325.3,194.72,324.18,195.37Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M328,189.16l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.05-24.54a.57.57,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.56.56,0,0,1,328,189.16Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M328,189.16l.06,24.54a.57.57,0,0,0,.32.46l.17.08-.06-24.54-.16-.08a.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5,189.7l.06,24.54a1.24,1.24,0,0,0,.39.09l-.06-24.54a1.38,1.38,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M328.89,189.79l.06,24.54a1.69,1.69,0,0,0,1-.17.09.09,0,0,0,.06,0L330,189.58l-.06,0a1.73,1.73,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M330,189.58l.05,24.54a.7.7,0,0,0,.21-.21l-.05-24.54a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M330.2,189.37l.05,24.54a.34.34,0,0,0,.06-.21l-.05-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M328.34,188.7a.49.49,0,0,0,0,.92,1.72,1.72,0,0,0,1.59,0c.43-.26.44-.67,0-.92A1.78,1.78,0,0,0,328.34,188.7Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M324.34,183.56c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.62-4.83-9.62S324.34,178.24,324.34,183.56Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M324.34,183.56c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.62-4.83-9.62S324.34,178.24,324.34,183.56Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M320.9,183.07l-1-.62a.58.58,0,0,0-.26-.06.91.91,0,0,0-.35.12l1.06.62a.91.91,0,0,1,.35-.12.35.35,0,0,1,.25.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M320.3,183.13l-1.06-.62c-1.13.66-2.86,3.92-4.07,7.79s-1.49,7.1-.69,7.56l1.06.62c-.8-.47-.53-3.65.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M320.3,183.13c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.29-1.53,7.7-.43,7.63a.87.87,0,0,0,.34-.12c1.13-.66,2.86-3.92,4.07-7.78,1.34-4.29,1.54-7.71.44-7.63A.91.91,0,0,0,320.3,183.13Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M311.12,187.06l-1.06-.62a1.14,1.14,0,0,0-1.17-.1L310,187a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M310,187l-1.06-.62a1.3,1.3,0,0,0-.2.15c-1.1,1-.95,4.67.31,8.13.84,2.27,1.95,3.9,2.92,4.46l1.06.62c-1-.57-2.08-2.19-2.91-4.46-1.27-3.46-1.42-7.1-.32-8.13a1.3,1.3,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M310,187a1.3,1.3,0,0,0-.2.15c-1.1,1-.95,4.67.32,8.13,1.2,3.26,3,5.2,4.08,4.56a1.3,1.3,0,0,0,.2-.15c1.1-1,1-4.67-.31-8.13C312.84,188.26,311.07,186.32,310,187Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M313.79,180.75l0,24.55a.55.55,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.32-.46L316,180.75a.56.56,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.57.57,0,0,1,313.79,180.75Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M313.79,180.75l0,24.55a.55.55,0,0,0,.33.45l.16.08-.05-24.54-.17-.08a.57.57,0,0,1-.32-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M314.28,181.29l.05,24.54a1.59,1.59,0,0,0,.39.1l-.06-24.54a1.64,1.64,0,0,1-.38-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M314.66,181.39l.06,24.54a1.81,1.81,0,0,0,1-.18l.05,0-.05-24.55-.06,0a1.8,1.8,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M315.76,181.17l.05,24.55a.62.62,0,0,0,.21-.22L316,181a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M316,181l0,24.54a.32.32,0,0,0,.06-.21L316,180.75a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M314.11,180.29c-.44.26-.44.67,0,.92a1.72,1.72,0,0,0,1.59,0c.44-.25.44-.66,0-.92A1.78,1.78,0,0,0,314.11,180.29Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M310.11,175.15c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S310.11,169.84,310.11,175.15Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M310.11,175.15c0,5.3,2.16,8.34,4.82,8.34s4.83-3,4.83-8.34-3.12-9.61-4.83-9.61S310.11,169.84,310.11,175.15Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M306.24,174.65l-1.07-.61a.36.36,0,0,0-.25-.06.86.86,0,0,0-.35.12l1.06.62a.86.86,0,0,1,.35-.12.47.47,0,0,1,.26.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M305.63,174.72l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.69,7.57l1.06.62c-.8-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M305.63,174.72c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.53,7.7-.43,7.62a1,1,0,0,0,.34-.11c1.13-.66,2.86-3.92,4.07-7.79,1.34-4.28,1.53-7.7.44-7.62A.86.86,0,0,0,305.63,174.72Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M296.45,178.65l-1.06-.62a1.12,1.12,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M295.28,178.55l-1.06-.62a1,1,0,0,0-.2.15c-1.1,1-.95,4.67.31,8.13.83,2.27,1.95,3.89,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.91-4.46-1.27-3.47-1.42-7.11-.32-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M295.28,178.55a1,1,0,0,0-.2.15c-1.1,1-.95,4.66.32,8.13,1.19,3.26,3,5.2,4.08,4.55a.9.9,0,0,0,.2-.14c1.09-1,1-4.67-.31-8.14C298.17,179.84,296.4,177.9,295.28,178.55Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M299.11,172.34l.06,24.54a.57.57,0,0,0,.32.46,1.75,1.75,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,299.11,172.34Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M299.11,172.34l.06,24.54a.57.57,0,0,0,.32.46l.17.08-.06-24.54-.16-.08a.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M299.6,172.88l.06,24.54a1.59,1.59,0,0,0,.39.1L300,173a1.83,1.83,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M300,173l.06,24.55a1.77,1.77,0,0,0,1-.18.09.09,0,0,0,.06,0l-.05-24.54-.06,0a1.73,1.73,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M301.09,172.76l.05,24.54a.7.7,0,0,0,.21-.21l-.05-24.54a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M301.3,172.55l.05,24.54a.42.42,0,0,0,.06-.21l-.05-24.55a.43.43,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M299.44,171.88a.49.49,0,0,0,0,.92,1.78,1.78,0,0,0,1.59,0c.43-.26.44-.67,0-.92A1.78,1.78,0,0,0,299.44,171.88Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M295.44,166.73c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S295.44,161.43,295.44,166.73Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M295.44,166.73c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S295.44,161.43,295.44,166.73Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M362.06,230.52,361,229.9a.46.46,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.87.87,0,0,1,.34-.12.38.38,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M361.46,230.58,360.4,230c-1.14.65-2.86,3.91-4.07,7.78s-1.49,7.11-.69,7.57l1.06.62c-.8-.46-.53-3.65.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M361.46,230.58c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a.76.76,0,0,0,.35-.13c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.28,1.54-7.7.43-7.62A.87.87,0,0,0,361.46,230.58Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M352.28,234.51l-1.06-.62a1.14,1.14,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M351.11,234.41l-1.06-.62a.75.75,0,0,0-.2.15c-1.1,1-1,4.67.31,8.13.83,2.27,1.95,3.9,2.92,4.46l1.06.62c-1-.57-2.08-2.19-2.91-4.46-1.27-3.47-1.42-7.1-.32-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M351.11,234.41a1,1,0,0,0-.2.15c-1.1,1-1,4.66.32,8.13,1.19,3.26,3,5.2,4.08,4.56a1,1,0,0,0,.2-.15c1.09-1,.95-4.67-.32-8.13C354,235.7,352.22,233.77,351.11,234.41Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M354.94,228.21l.06,24.53a.55.55,0,0,0,.32.46,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.05-24.54a.56.56,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.55.55,0,0,1,354.94,228.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M354.94,228.21l.06,24.53a.55.55,0,0,0,.32.46l.17.08-.06-24.54-.16-.08a.55.55,0,0,1-.33-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M355.43,228.74l.06,24.54a1.64,1.64,0,0,0,.38.1l-.05-24.54a1.72,1.72,0,0,1-.39-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M355.82,228.84l.05,24.54a1.72,1.72,0,0,0,1-.18l.06,0-.05-24.54-.06,0a1.74,1.74,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M356.92,228.62l.05,24.54a.6.6,0,0,0,.21-.21l-.05-24.54a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M357.13,228.41l.05,24.54a.39.39,0,0,0,.06-.21l-.05-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M355.27,227.74c-.43.26-.44.67,0,.92a1.78,1.78,0,0,0,1.59,0c.44-.25.44-.66,0-.92A1.78,1.78,0,0,0,355.27,227.74Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M351.27,222.59c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S351.27,217.29,351.27,222.59Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M351.27,222.59c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.6-4.83-9.6S351.27,217.29,351.27,222.59Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M346.6,222.21l-1.06-.61a.39.39,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.82.82,0,0,1,.34-.12.45.45,0,0,1,.26.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M346,222.28l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.7,7.57l1.06.62c-.79-.47-.53-3.65.7-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M346,222.28c-1.13.65-2.86,3.9-4.07,7.78-1.34,4.28-1.54,7.7-.44,7.62a.91.91,0,0,0,.35-.12c1.13-.65,2.85-3.91,4.07-7.78,1.34-4.28,1.53-7.7.43-7.62A.82.82,0,0,0,346,222.28Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M336.81,226.2l-1.05-.61a1.11,1.11,0,0,0-1.18-.1l1.06.62a1.11,1.11,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64,226.11l-1.06-.62a.9.9,0,0,0-.19.15c-1.1,1-1,4.67.31,8.13.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.57-2.09-2.2-2.92-4.46-1.27-3.47-1.41-7.11-.31-8.13a1.25,1.25,0,0,1,.19-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M335.64,226.11a1.25,1.25,0,0,0-.19.15c-1.1,1-1,4.66.31,8.13,1.2,3.26,3,5.2,4.09,4.55l.2-.14c1.09-1,.95-4.67-.32-8.14C338.53,227.4,336.77,225.46,335.64,226.11Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M339.48,219.9l.06,24.54a.53.53,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l0-24.54a.59.59,0,0,1-.34.46,1.76,1.76,0,0,1-1.58,0A.56.56,0,0,1,339.48,219.9Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M339.48,219.9l.06,24.54a.53.53,0,0,0,.32.46l.16.08,0-24.54a.67.67,0,0,1-.17-.08.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M340,220.44,340,245a1.38,1.38,0,0,0,.39.09l-.05-24.53a1.41,1.41,0,0,1-.38-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M340.36,220.54l.05,24.53a1.72,1.72,0,0,0,1-.17l.06,0-.06-24.54-.06,0a1.78,1.78,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M341.45,220.32l.06,24.54a.7.7,0,0,0,.21-.21l-.06-24.54a.6.6,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M341.66,220.11l.06,24.54a.42.42,0,0,0,.06-.21l0-24.54a.35.35,0,0,1-.07.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M339.81,219.44a.49.49,0,0,0,0,.92,1.76,1.76,0,0,0,1.58,0,.48.48,0,0,0,0-.92A1.72,1.72,0,0,0,339.81,219.44Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M335.8,214.29c0,5.31,2.16,8.35,4.83,8.35s4.82-3,4.82-8.35-3.12-9.61-4.82-9.61S335.8,209,335.8,214.29Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M335.8,214.29c0,5.31,2.16,8.35,4.83,8.35s4.82-3,4.82-8.35-3.12-9.61-4.82-9.61S335.8,209,335.8,214.29Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M331.29,212.93l-1.06-.62a.46.46,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.74.74,0,0,1,.34-.12.39.39,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M330.69,213l-1.06-.62c-1.14.66-2.86,3.91-4.07,7.78s-1.5,7.1-.7,7.57l1.06.62c-.8-.47-.53-3.66.7-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M330.69,213c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.62a.78.78,0,0,0,.35-.11c1.13-.66,2.85-3.92,4.06-7.78,1.35-4.29,1.54-7.71.44-7.63A.74.74,0,0,0,330.69,213Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M321.51,216.91l-1.06-.61a1.14,1.14,0,0,0-1.18-.1l1.06.62a1.13,1.13,0,0,1,1.18.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M320.33,216.82l-1.06-.62-.2.15c-1.09,1-.95,4.67.32,8.13.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.57-2.09-2.2-2.92-4.46-1.27-3.46-1.41-7.11-.32-8.13a1.3,1.3,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M320.33,216.82a1.3,1.3,0,0,0-.2.15c-1.09,1-.95,4.67.32,8.13,1.2,3.26,3,5.2,4.09,4.55a1.15,1.15,0,0,0,.19-.14c1.1-1,1-4.67-.31-8.13C323.22,218.11,321.45,216.17,320.33,216.82Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M324.17,210.62l.05,24.53a.56.56,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.46l-.06-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.57.57,0,0,1,324.17,210.62Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M324.17,210.62l.05,24.53a.56.56,0,0,0,.33.46l.17.08-.06-24.54-.17-.08a.57.57,0,0,1-.32-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M324.66,211.15l.06,24.54a1.64,1.64,0,0,0,.38.1L325,211.24a1.24,1.24,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M325,211.24l.06,24.55a1.81,1.81,0,0,0,1-.18l.06,0L326.14,211s0,0-.06,0a1.71,1.71,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M326.14,211l.06,24.54a.7.7,0,0,0,.21-.21l-.06-24.54a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M326.35,210.82l.06,24.54a.42.42,0,0,0,.06-.21l-.06-24.55a.43.43,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5,210.15c-.44.26-.44.66,0,.92a1.78,1.78,0,0,0,1.59,0c.45-.26.45-.66,0-.92A1.78,1.78,0,0,0,324.5,210.15Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M320.49,205c0,5.31,2.16,8.35,4.83,8.35s4.82-3,4.82-8.35-3.11-9.6-4.82-9.6S320.49,199.7,320.49,205Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M320.49,205c0,5.31,2.16,8.35,4.83,8.35s4.82-3,4.82-8.35-3.11-9.6-4.82-9.6S320.49,199.7,320.49,205Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M314.54,203.58l-1.06-.62a.45.45,0,0,0-.26-.05.82.82,0,0,0-.34.12l1.06.61a.68.68,0,0,1,.34-.11.44.44,0,0,1,.26.05Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M313.94,203.64l-1.06-.61c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.7,7.57l1.06.61c-.79-.46-.53-3.65.7-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M313.94,203.64c-1.13.66-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a1,1,0,0,0,.35-.12c1.13-.65,2.86-3.91,4.07-7.78,1.33-4.29,1.53-7.7.43-7.62A.68.68,0,0,0,313.94,203.64Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M304.75,207.57l-1.06-.62a1.1,1.1,0,0,0-1.16-.09l1.06.61a1.1,1.1,0,0,1,1.16.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M303.59,207.47l-1.06-.61a1,1,0,0,0-.2.15c-1.1,1-1,4.66.31,8.13.83,2.26,1.94,3.89,2.92,4.46l1.06.61c-1-.56-2.09-2.19-2.92-4.46-1.27-3.46-1.41-7.1-.31-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M303.59,207.47a1,1,0,0,0-.2.15c-1.1,1-1,4.67.31,8.13,1.2,3.26,3,5.21,4.09,4.56a1.3,1.3,0,0,0,.2-.15c1.09-1,.95-4.66-.32-8.13C306.47,208.77,304.7,206.83,303.59,207.47Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M307.42,201.27l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.57.57,0,0,1-.33.47,1.76,1.76,0,0,1-1.58,0A.57.57,0,0,1,307.42,201.27Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M307.42,201.27l.06,24.54a.56.56,0,0,0,.32.46l.17.08-.06-24.55-.16-.07a.57.57,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M307.91,201.8l.06,24.55a1.62,1.62,0,0,0,.38.09l-.05-24.54a1.59,1.59,0,0,1-.39-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M308.3,201.9l.05,24.54a1.72,1.72,0,0,0,1-.17l.06,0-.06-24.54-.06,0a1.69,1.69,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M309.39,201.69l.06,24.54a1,1,0,0,0,.21-.21l-.06-24.55a.62.62,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M309.6,201.47l.06,24.55a.43.43,0,0,0,.06-.22l-.06-24.54a.31.31,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M307.75,200.81c-.44.25-.44.66,0,.92a1.76,1.76,0,0,0,1.58,0c.45-.26.45-.67,0-.92A1.72,1.72,0,0,0,307.75,200.81Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M303.74,195.66c0,5.31,2.17,8.34,4.83,8.34s4.83-3,4.83-8.34-3.13-9.61-4.83-9.61S303.74,190.35,303.74,195.66Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M303.74,195.66c0,5.31,2.17,8.34,4.83,8.34s4.83-3,4.83-8.34-3.13-9.61-4.83-9.61S303.74,190.35,303.74,195.66Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M300.31,195.18l-1.06-.62a.38.38,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.78.78,0,0,1,.34-.12.38.38,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M299.71,195.24l-1.06-.62c-1.13.65-2.86,3.91-4.07,7.78s-1.49,7.1-.7,7.57l1.07.62c-.8-.47-.53-3.66.69-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M299.71,195.24c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.53,7.7-.44,7.62a.73.73,0,0,0,.35-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.28,1.54-7.7.43-7.62A.78.78,0,0,0,299.71,195.24Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M290.53,199.16l-1.06-.61a1.14,1.14,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M289.36,199.07l-1.06-.62a1,1,0,0,0-.2.15c-1.1,1-1,4.67.31,8.13.83,2.27,1.95,3.89,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.92-4.46-1.27-3.47-1.41-7.11-.31-8.14a.9.9,0,0,1,.2-.14Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M289.36,199.07a.9.9,0,0,0-.2.14c-1.1,1-1,4.67.31,8.14,1.2,3.25,3,5.2,4.09,4.55l.2-.14c1.09-1,.95-4.67-.32-8.14C292.25,200.36,290.47,198.42,289.36,199.07Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M293.19,192.86l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.46l-.05-24.54a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,293.19,192.86Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M293.19,192.86l.06,24.54a.57.57,0,0,0,.32.46l.17.08-.05-24.54-.17-.08a.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M293.69,193.4l.05,24.54a1.62,1.62,0,0,0,.38.09l-.05-24.54a1.51,1.51,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M294.07,193.49l.05,24.54a1.71,1.71,0,0,0,1-.17l.06,0-.06-24.54-.05,0a1.73,1.73,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M295.16,193.28l.06,24.54a.6.6,0,0,0,.21-.21l-.06-24.54a.6.6,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M295.37,193.07l.06,24.54a.42.42,0,0,0,.06-.21l-.05-24.54a.44.44,0,0,1-.07.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M293.52,192.4a.49.49,0,0,0,0,.92,1.78,1.78,0,0,0,1.59,0c.43-.26.44-.67,0-.92A1.78,1.78,0,0,0,293.52,192.4Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M289.52,187.25c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S289.52,181.94,289.52,187.25Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M289.52,187.25c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S289.52,181.94,289.52,187.25Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-17)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M285.64,186.76l-1.06-.62a.45.45,0,0,0-.26,0,.7.7,0,0,0-.34.12l1.06.61a.87.87,0,0,1,.34-.12.53.53,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M285,186.82l-1.06-.61c-1.13.65-2.86,3.91-4.07,7.78s-1.5,7.1-.7,7.57l1.06.61c-.79-.46-.53-3.65.7-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M285,186.82c-1.13.66-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a.78.78,0,0,0,.34-.12c1.14-.65,2.87-3.91,4.08-7.78,1.33-4.29,1.53-7.7.43-7.63A.87.87,0,0,0,285,186.82Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M275.86,190.75l-1.07-.62a1.14,1.14,0,0,0-1.17-.09l1.06.62a1.13,1.13,0,0,1,1.18.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M274.68,190.66l-1.06-.62a1.25,1.25,0,0,0-.19.15c-1.1,1-1,4.66.31,8.13.83,2.26,1.94,3.89,2.91,4.46l1.07.61c-1-.56-2.09-2.19-2.92-4.46-1.27-3.46-1.41-7.1-.31-8.13a.77.77,0,0,1,.19-.14Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M274.68,190.66a.77.77,0,0,0-.19.14c-1.1,1-1,4.67.31,8.13,1.2,3.26,3,5.21,4.09,4.56a1.3,1.3,0,0,0,.2-.15c1.09-1,1-4.66-.32-8.13C277.57,192,275.8,190,274.68,190.66Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M278.52,184.45l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.55.55,0,0,1-.33.46,1.7,1.7,0,0,1-1.58,0A.55.55,0,0,1,278.52,184.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M278.52,184.45l.06,24.54a.56.56,0,0,0,.32.46l.17.08L279,185a.6.6,0,0,1-.16-.08.55.55,0,0,1-.33-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M279,185l.06,24.55a2.34,2.34,0,0,0,.38.09l-.05-24.54a1.59,1.59,0,0,1-.39-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M279.4,185.08l.05,24.54a1.72,1.72,0,0,0,1-.17l.06,0-.06-24.54-.06,0a1.62,1.62,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M280.49,184.87l.06,24.54a.83.83,0,0,0,.21-.21l-.06-24.55a.55.55,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M280.7,184.65l.06,24.55a.46.46,0,0,0,.06-.22l-.06-24.54a.32.32,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M278.85,184a.48.48,0,0,0,0,.91,1.7,1.7,0,0,0,1.58,0,.48.48,0,0,0,0-.91A1.72,1.72,0,0,0,278.85,184Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M274.84,178.84c0,5.3,2.17,8.34,4.83,8.34s4.83-3,4.83-8.34-3.13-9.61-4.83-9.61S274.84,173.53,274.84,178.84Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M274.84,178.84c0,5.3,2.17,8.34,4.83,8.34s4.83-3,4.83-8.34-3.13-9.61-4.83-9.61S274.84,173.53,274.84,178.84Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M337.89,244.41l-1.06-.61a.46.46,0,0,0-.26-.06.87.87,0,0,0-.34.12l1.06.62a.74.74,0,0,1,.34-.12.45.45,0,0,1,.26,0Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M337.29,244.48l-1.06-.62c-1.13.66-2.87,3.91-4.07,7.78s-1.49,7.11-.69,7.57l1.06.61c-.8-.46-.54-3.64.69-7.56s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M337.29,244.48c-1.13.65-2.86,3.91-4.07,7.78-1.34,4.28-1.54,7.7-.44,7.62a.82.82,0,0,0,.34-.12c1.14-.65,2.87-3.91,4.08-7.78,1.34-4.28,1.54-7.7.43-7.62A.74.74,0,0,0,337.29,244.48Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M328.11,248.4l-1.06-.61a1.14,1.14,0,0,0-1.18-.1l1.07.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94,248.31l-1.07-.62a1.25,1.25,0,0,0-.19.15c-1.1,1-1,4.67.31,8.13.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.57-2.08-2.2-2.92-4.46-1.27-3.47-1.41-7.1-.31-8.13a1,1,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94,248.31a1,1,0,0,0-.2.15c-1.1,1-1,4.66.31,8.13,1.2,3.26,3,5.2,4.09,4.55a.87.87,0,0,0,.2-.15c1.09-1,1-4.66-.32-8.12C329.82,249.61,328.05,247.66,326.94,248.31Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M330.77,242.1l.06,24.54a.57.57,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.56.56,0,0,0,.33-.46L333,242.1a.55.55,0,0,1-.33.46,1.76,1.76,0,0,1-1.58,0A.56.56,0,0,1,330.77,242.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M330.77,242.1l.06,24.54a.57.57,0,0,0,.32.46l.17.08-.06-24.54a.8.8,0,0,1-.16-.08.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M331.26,242.64l.06,24.54a1.64,1.64,0,0,0,.38.1l-.05-24.54a1.59,1.59,0,0,1-.39-.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M331.65,242.74l.05,24.54a1.8,1.8,0,0,0,1-.18l.06,0-.06-24.54-.06,0a1.77,1.77,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M332.74,242.52l.06,24.54a.7.7,0,0,0,.21-.21L333,242.31a.74.74,0,0,1-.22.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M333,242.31l.05,24.54a.42.42,0,0,0,.06-.21L333,242.1a.41.41,0,0,1-.05.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M331.1,241.64a.49.49,0,0,0,0,.92,1.76,1.76,0,0,0,1.58,0c.44-.25.45-.67,0-.92A1.72,1.72,0,0,0,331.1,241.64Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M327.1,236.49c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S327.1,231.18,327.1,236.49Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M327.1,236.49c0,5.31,2.16,8.35,4.82,8.35s4.83-3,4.83-8.35-3.12-9.61-4.83-9.61S327.1,231.18,327.1,236.49Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M322.43,236.11l-1.06-.62a.47.47,0,0,0-.26-.05.64.64,0,0,0-.34.12l1.06.61a.87.87,0,0,1,.34-.12.55.55,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M321.83,236.17l-1.06-.61c-1.14.65-2.87,3.91-4.08,7.78s-1.49,7.1-.69,7.57l1.06.61c-.8-.46-.53-3.65.7-7.57s2.93-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M321.83,236.17c-1.14.66-2.86,3.91-4.07,7.78-1.34,4.29-1.54,7.71-.44,7.63a.82.82,0,0,0,.34-.12c1.13-.65,2.86-3.91,4.07-7.78,1.34-4.29,1.54-7.7.44-7.63A.87.87,0,0,0,321.83,236.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M312.65,240.1l-1.07-.61a1.12,1.12,0,0,0-1.17-.1l1.06.61a1.16,1.16,0,0,1,1.18.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M311.47,240l-1.06-.61a1.3,1.3,0,0,0-.2.15c-1.09,1-.95,4.66.32,8.12.83,2.27,1.94,3.9,2.92,4.47l1.05.61c-1-.56-2.08-2.19-2.91-4.46-1.27-3.46-1.41-7.1-.31-8.13.06-.06.13-.1.19-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M311.47,240c-.06.05-.13.09-.19.15-1.1,1-1,4.67.31,8.13,1.2,3.26,3,5.21,4.09,4.56a1.25,1.25,0,0,0,.19-.15c1.1-1,1-4.66-.31-8.13C314.36,241.3,312.59,239.36,311.47,240Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M315.31,233.8l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.57.57,0,0,0,.34-.46l-.06-24.55a.57.57,0,0,1-.33.47,1.78,1.78,0,0,1-1.59,0A.58.58,0,0,1,315.31,233.8Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M315.31,233.8l.05,24.54a.56.56,0,0,0,.33.46l.17.07-.06-24.53-.17-.08a.58.58,0,0,1-.32-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M315.8,234.34l.06,24.53a1.18,1.18,0,0,0,.38.1l-.05-24.54a2.23,2.23,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M316.19,234.43l.05,24.54a1.68,1.68,0,0,0,1-.17.15.15,0,0,0,.06,0l-.05-24.54-.06,0a1.69,1.69,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M317.28,234.22l.05,24.54a.74.74,0,0,0,.22-.21L317.49,234a.69.69,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M317.49,234l.06,24.54a.42.42,0,0,0,.06-.21l-.06-24.55a.43.43,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M315.64,233.34a.49.49,0,0,0,0,.92,1.78,1.78,0,0,0,1.59,0c.44-.26.44-.67,0-.92A1.7,1.7,0,0,0,315.64,233.34Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M311.63,228.19c0,5.31,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S311.63,222.88,311.63,228.19Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M311.63,228.19c0,5.31,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S311.63,222.88,311.63,228.19Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M307.11,226.82l-1.06-.61a.36.36,0,0,0-.25-.06.82.82,0,0,0-.34.12l1.06.61a.68.68,0,0,1,.34-.11.4.4,0,0,1,.25,0Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M306.52,226.88l-1.06-.61c-1.14.65-2.87,3.91-4.08,7.78s-1.49,7.1-.69,7.57l1.06.61c-.8-.46-.53-3.65.69-7.56s2.94-7.13,4.08-7.79Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M306.52,226.88c-1.14.66-2.87,3.92-4.08,7.79-1.33,4.28-1.53,7.69-.43,7.62a.87.87,0,0,0,.34-.12c1.13-.65,2.87-3.91,4.07-7.78,1.35-4.29,1.54-7.7.44-7.62A.68.68,0,0,0,306.52,226.88Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M297.33,230.81l-1.06-.61a1.12,1.12,0,0,0-1.17-.1l1.06.62a1.12,1.12,0,0,1,1.17.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M296.16,230.72l-1.06-.62a1,1,0,0,0-.2.15c-1.09,1-.95,4.67.32,8.13.83,2.26,1.94,3.89,2.91,4.46l1.07.62c-1-.57-2.09-2.2-2.92-4.47-1.27-3.46-1.41-7.1-.32-8.12a.87.87,0,0,1,.2-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M296.16,230.72a.87.87,0,0,0-.2.15c-1.09,1-.95,4.66.32,8.12,1.2,3.27,3,5.21,4.09,4.56a.9.9,0,0,0,.19-.15c1.1-1,1-4.66-.31-8.13C299.06,232,297.28,230.07,296.16,230.72Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M300,224.51l.05,24.54a.56.56,0,0,0,.33.46,1.76,1.76,0,0,0,1.58,0,.59.59,0,0,0,.34-.46l-.06-24.54a.57.57,0,0,1-.33.46,1.78,1.78,0,0,1-1.59,0A.57.57,0,0,1,300,224.51Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M300,224.51l.05,24.54a.56.56,0,0,0,.33.46l.16.08-.05-24.54-.17-.08a.57.57,0,0,1-.32-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M300.49,225.05l.05,24.54a2.22,2.22,0,0,0,.39.1l-.06-24.55a1.62,1.62,0,0,1-.38-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M300.87,225.14l.06,24.55a1.77,1.77,0,0,0,1-.18l.06,0,0-24.54-.06,0a1.71,1.71,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M302,224.93l0,24.54a.74.74,0,0,0,.22-.21l-.06-24.54a.6.6,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M302.18,224.72l.06,24.54a.42.42,0,0,0,.06-.21l-.06-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M300.33,224.05a.49.49,0,0,0,0,.92,1.78,1.78,0,0,0,1.59,0c.44-.26.44-.67,0-.92A1.76,1.76,0,0,0,300.33,224.05Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M296.32,218.9c0,5.31,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.11-9.6-4.82-9.6S296.32,213.59,296.32,218.9Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M296.32,218.9c0,5.31,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.11-9.6-4.82-9.6S296.32,213.59,296.32,218.9Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M290.37,217.48l-1.06-.62a.45.45,0,0,0-.26-.05.78.78,0,0,0-.35.11l1.06.62a.91.91,0,0,1,.35-.12.46.46,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76,217.54l-1.06-.62c-1.13.66-2.85,3.91-4.06,7.78s-1.5,7.11-.7,7.57l1.06.62c-.8-.47-.53-3.65.7-7.57s2.94-7.13,4.06-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76,217.54c-1.12.65-2.85,3.91-4.06,7.78-1.34,4.29-1.54,7.7-.44,7.63a.82.82,0,0,0,.34-.12c1.13-.65,2.87-3.91,4.08-7.78,1.34-4.29,1.53-7.71.43-7.63A.91.91,0,0,0,289.76,217.54Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M280.59,221.47l-1.06-.62a1.16,1.16,0,0,0-1.18-.1l1.06.62a1.16,1.16,0,0,1,1.18.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M279.41,221.37l-1.06-.62a1.4,1.4,0,0,0-.2.16c-1.1,1-.95,4.66.32,8.12.83,2.27,1.94,3.9,2.92,4.46l1.06.62c-1-.56-2.09-2.19-2.92-4.46-1.27-3.46-1.41-7.1-.31-8.13a.9.9,0,0,1,.19-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M279.41,221.37a.9.9,0,0,0-.19.15c-1.1,1-1,4.67.31,8.13,1.19,3.26,3,5.2,4.09,4.56a1.25,1.25,0,0,0,.19-.15c1.1-1,1-4.67-.31-8.13C282.3,222.67,280.53,220.73,279.41,221.37Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25,215.17l.05,24.54a.59.59,0,0,0,.33.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,283.25,215.17Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M283.25,215.17l.05,24.54a.59.59,0,0,0,.33.46l.16.07-.05-24.53-.17-.09a.55.55,0,0,1-.32-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M283.74,215.71l.05,24.53a1.72,1.72,0,0,0,.39.1l-.05-24.54a2.23,2.23,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M284.13,215.8l.05,24.54a1.73,1.73,0,0,0,1-.17l.06,0-.06-24.54-.06,0a1.7,1.7,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M285.22,215.59l.06,24.54a.86.86,0,0,0,.21-.22l-.06-24.54a.72.72,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M285.43,215.37l.06,24.54a.42.42,0,0,0,.06-.21l-.06-24.54a.42.42,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M283.58,214.7c-.44.26-.44.67,0,.92a1.72,1.72,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.78,1.78,0,0,0,283.58,214.7Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M279.57,209.56c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34S286.1,200,284.4,200,279.57,204.25,279.57,209.56Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M279.57,209.56c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34S286.1,200,284.4,200,279.57,204.25,279.57,209.56Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-22)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M276.14,209.07l-1.06-.61a.39.39,0,0,0-.26-.06.82.82,0,0,0-.34.12l1.06.61a.82.82,0,0,1,.34-.12.55.55,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M275.54,209.13l-1.06-.61c-1.14.65-2.87,3.91-4.07,7.78s-1.5,7.1-.7,7.57l1.06.61c-.8-.46-.52-3.65.7-7.57s2.94-7.12,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M275.54,209.13c-1.13.66-2.86,3.92-4.07,7.78-1.34,4.29-1.54,7.7-.44,7.63a.82.82,0,0,0,.34-.12c1.14-.65,2.86-3.91,4.08-7.78,1.34-4.29,1.53-7.7.43-7.63A.82.82,0,0,0,275.54,209.13Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M266.36,213.06l-1.06-.62a1.16,1.16,0,0,0-1.18-.09l1.06.62a1.13,1.13,0,0,1,1.18.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M265.18,213l-1.06-.62-.2.15c-1.09,1-.95,4.67.32,8.12.83,2.27,1.94,3.9,2.91,4.47l1.06.62c-1-.57-2.08-2.2-2.91-4.47-1.27-3.46-1.41-7.1-.31-8.13a.77.77,0,0,1,.19-.14Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M265.18,213a.77.77,0,0,0-.19.14c-1.1,1-1,4.67.31,8.13,1.2,3.27,3,5.21,4.09,4.56a1.3,1.3,0,0,0,.2-.15c1.09-1,1-4.66-.32-8.13C268.08,214.26,266.3,212.32,265.18,213Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M269,206.76l.06,24.54a.56.56,0,0,0,.32.46,1.78,1.78,0,0,0,1.59,0,.57.57,0,0,0,.33-.47l-.06-24.54a.58.58,0,0,1-.32.47,1.78,1.78,0,0,1-1.59,0A.56.56,0,0,1,269,206.76Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M269,206.76l.06,24.54a.56.56,0,0,0,.32.46l.17.08-.06-24.54-.16-.08a.56.56,0,0,1-.33-.46Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M269.51,207.3l.06,24.54a2.34,2.34,0,0,0,.38.09l-.05-24.54a2.23,2.23,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M269.9,207.39l.05,24.54a1.72,1.72,0,0,0,1-.17l.06,0L271,207.18a.1.1,0,0,0-.05,0,1.73,1.73,0,0,1-1,.17Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M271,207.18l.06,24.54a1,1,0,0,0,.21-.21L271.2,207a.7.7,0,0,1-.21.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M271.2,207l.06,24.54a.43.43,0,0,0,.06-.22l-.06-24.54a.37.37,0,0,1-.06.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M269.35,206.29a.49.49,0,0,0,0,.93,1.78,1.78,0,0,0,1.59,0,.5.5,0,0,0,0-.93A1.78,1.78,0,0,0,269.35,206.29Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M265.34,201.15c0,5.31,2.17,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S265.34,195.84,265.34,201.15Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M265.34,201.15c0,5.31,2.17,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S265.34,195.84,265.34,201.15Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M261.47,200.66l-1.06-.62a.45.45,0,0,0-.26,0,.8.8,0,0,0-.34.11l1.06.62a.82.82,0,0,1,.34-.12.39.39,0,0,1,.26.06Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M260.87,200.72l-1.06-.62c-1.14.66-2.86,3.92-4.07,7.78s-1.5,7.11-.7,7.57l1.06.62c-.8-.47-.53-3.65.7-7.57s2.94-7.13,4.07-7.78Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M260.87,200.72c-1.13.65-2.86,3.91-4.07,7.78-1.35,4.29-1.54,7.7-.44,7.63a.82.82,0,0,0,.34-.12c1.13-.66,2.87-3.91,4.07-7.78,1.34-4.29,1.54-7.7.44-7.63A.82.82,0,0,0,260.87,200.72Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M251.68,204.65l-1.06-.62a1.14,1.14,0,0,0-1.17-.09l1.06.61a1.12,1.12,0,0,1,1.17.1Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M250.51,204.55l-1.06-.61a.87.87,0,0,0-.2.15c-1.09,1-.95,4.66.32,8.12.83,2.27,1.94,3.9,2.91,4.46l1.07.62c-1-.56-2.09-2.19-2.92-4.46-1.27-3.46-1.41-7.1-.31-8.13a.9.9,0,0,1,.19-.15Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M250.51,204.55a.9.9,0,0,0-.19.15c-1.1,1-1,4.67.31,8.13,1.19,3.26,3,5.2,4.09,4.56a1.25,1.25,0,0,0,.19-.15c1.1-1,1-4.67-.31-8.13C253.4,205.85,251.63,203.91,250.51,204.55Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M254.35,198.35l.05,24.54a.55.55,0,0,0,.33.45,1.72,1.72,0,0,0,1.59,0,.55.55,0,0,0,.33-.46l-.06-24.54a.55.55,0,0,1-.33.46,1.72,1.72,0,0,1-1.59,0A.55.55,0,0,1,254.35,198.35Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M254.35,198.35l.05,24.54a.55.55,0,0,0,.33.45l.17.09-.06-24.54-.17-.09a.55.55,0,0,1-.32-.45Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M254.84,198.89l.06,24.54a2.11,2.11,0,0,0,.38.09L255.23,199a2.23,2.23,0,0,1-.39-.09Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M255.23,199l.05,24.54a1.67,1.67,0,0,0,1-.18l.06,0-.06-24.53-.06,0a1.69,1.69,0,0,1-1,.18Z",
    transform: "translate(0 -13)",
    fill: "#8dc63f"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M256.32,198.77l.06,24.53a.7.7,0,0,0,.21-.21l-.06-24.54a.62.62,0,0,1-.21.22Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M256.53,198.55l.06,24.54a.42.42,0,0,0,.06-.21l-.06-24.54a.39.39,0,0,1-.06.21Z",
    transform: "translate(0 -13)",
    fill: "#5c8e3e"
  })))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M254.68,197.88c-.44.26-.44.67,0,.92a1.72,1.72,0,0,0,1.59,0,.49.49,0,0,0,0-.92A1.78,1.78,0,0,0,254.68,197.88Z",
    transform: "translate(0 -13)",
    fill: "#222320"
  }))), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M250.67,192.74c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S250.67,187.43,250.67,192.74Z",
    transform: "translate(0 -13)",
    fill: "#f1605e"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M250.67,192.74c0,5.3,2.16,8.34,4.83,8.34s4.82-3,4.82-8.34-3.12-9.61-4.82-9.61S250.67,187.43,250.67,192.74Z",
    transform: "translate(0 -13)",
    fill: "url(#radial-gradient-24)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.98 109.56 383.07 120.4 413.48 138.07 413.38 127.22 382.98 109.56",
    fill: "#461f1d",
    fillRule: "evenodd"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.38 127.22 413.48 138.07 444.07 120.4 443.97 109.56 413.38 127.22",
    fill: "#211010",
    fillRule: "evenodd"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.98 109.56 413.38 127.22 443.97 109.56 413.57 91.89 382.98 109.56",
    fill: "#53221f",
    fillRule: "evenodd"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M413.25,111c.24-7.92.8-9.26,7.93-9.72C420.59,107.19,415.83,105,413.25,111Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M413.35,110.91a31.46,31.46,0,0,0,1.45-8.55c.06-2.57-.6-5.76-.08-8.07-1.11,1.22-.65,6-.75,8a76.32,76.32,0,0,1-1.22,8.53Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M418.88,122c.24-7.91.79-9.25,7.93-9.71C426.22,118.21,421.46,116,418.88,122Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M419,121.93a31.58,31.58,0,0,0,1.45-8.55c.05-2.57-.6-5.76-.08-8.07-1.11,1.22-.65,6-.75,8a76.64,76.64,0,0,1-1.22,8.53Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M407.14,127c.24-7.92.8-9.25,7.93-9.72C414.48,123.19,409.72,121,407.14,127Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M407.24,126.91a31.46,31.46,0,0,0,1.45-8.55c.06-2.57-.6-5.76-.08-8.06-1.11,1.22-.65,6-.75,8a76.21,76.21,0,0,1-1.22,8.52Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M394.68,126.25c.24-7.91.79-9.25,7.92-9.71C402,122.47,397.25,120.23,394.68,126.25Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M394.78,126.19a31,31,0,0,0,1.44-8.55c.06-2.57-.6-5.76-.07-8.07-1.11,1.22-.65,6-.76,8a74,74,0,0,1-1.22,8.53Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9,135c.24-7.91.79-9.25,7.92-9.72C421.23,131.24,416.47,129,413.9,135Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M414,135a31.08,31.08,0,0,0,1.44-8.56c.06-2.57-.6-5.76-.07-8.06-1.12,1.22-.65,6-.76,8a73.9,73.9,0,0,1-1.22,8.52Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M431.59,125.69c.24-7.91.79-9.25,7.92-9.71C438.92,121.9,434.17,119.67,431.59,125.69Z",
    transform: "translate(0 -13)",
    fill: "#b2ab3b",
    fillRule: "evenodd"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M431.69,125.63a31.08,31.08,0,0,0,1.44-8.56c.06-2.56-.59-5.75-.07-8.06-1.11,1.22-.65,6-.75,8a76.74,76.74,0,0,1-1.23,8.52Z",
    transform: "translate(0 -13)",
    fill: "#bfb234",
    fillRule: "evenodd"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M474.67,254.86l6.92,3.71c1.06,6.14,1.63,9.15-.21,11.23-2.59,2.94-7.92,2.24-10.86.46a6,6,0,0,0-1-.48c-1.4-.5-2.57-.58-4.17-1.25-5-2.12-11.91-6.19-13.76-11-1.15-3,1-6.15,5.07-5.33l10.12,2Z",
    transform: "translate(0 -13)",
    fill: "#44bb8c",
    fillRule: "evenodd"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M482.57,266.54a5,5,0,0,1-1.19,3.26c-2.59,2.94-7.92,2.24-10.86.46a6,6,0,0,0-1-.48c-1.4-.5-2.57-.58-4.17-1.25-5-2.12-11.91-6.19-13.76-11a4.24,4.24,0,0,1-.09-3c.87,4.71,9.91,10.41,18.36,13.28C475.37,269.67,481.35,270.16,482.57,266.54Z",
    transform: "translate(0 -13)",
    fill: "#113227",
    fillRule: "evenodd"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M465.41,207.34c1.16,3,4.33,7,5.55,9.77l11.91,45.52c-1.21,5.36-18.9-2.3-20-9.43l-12.37-39.48C445,197.21,463.62,191.85,465.41,207.34Z",
    transform: "translate(0 -13)",
    fill: "#1e3b3d",
    fillRule: "evenodd"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M456.6,263.88l7.34,2.81c1.84,5.95,2.78,8.86,1.23,11.16-2.2,3.24-7.58,3.23-10.72,1.84a5.39,5.39,0,0,0-1.05-.35c-1.44-.33-2.62-.25-4.29-.71-5.27-1.46-12.6-4.63-15.06-9.2-1.52-2.85.19-6.23,4.35-5.93l10.31.72Z",
    transform: "translate(0 -13)",
    fill: "#44bb8c",
    fillRule: "evenodd"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92,274.47a5,5,0,0,1-.75,3.38c-2.2,3.24-7.58,3.23-10.72,1.84a5.39,5.39,0,0,0-1.05-.35c-1.44-.33-2.62-.25-4.29-.71-5.27-1.46-12.6-4.63-15.06-9.2a4.29,4.29,0,0,1-.46-2.93c1.46,4.55,11.16,9.06,19.9,10.83C459.19,278.49,465.18,278.21,465.92,274.47Z",
    transform: "translate(0 -13)",
    fill: "#113227",
    fillRule: "evenodd"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M450.48,213.12c1.8,4.19,4.76,9.52,5.69,12.55l9.57,46c-1,3.43-10.75-.11-11.32-.37-5-2.28-9-6-8.65-8.38l-13-45.14C430.24,206,448.69,197.64,450.48,213.12Z",
    transform: "translate(0 -13)",
    fill: "#2f5153",
    fillRule: "evenodd"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M479.44,154.11c3.88,13.82,6.21,18.82-4.78,37.75-3.78,6.52-7.58,14.06-11.68,19.66-6,8.18-13.16,2.06-11-9.92,4-13.41,7.18-28.7,12-41.75Z",
    transform: "translate(0 -13)",
    fill: "#1e3b3d",
    fillRule: "evenodd"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M469.44,162.88c2.41,10.65,1.49,22.75-3.74,30.46-6.05,8.94-12.16,17.8-16.95,27.62-4.54,7.7-18.43,2.49-15.53-9,4.77-12.46,6.67-36.14,11.55-47Z",
    transform: "translate(0 -13)",
    fill: "#2f5153",
    fillRule: "evenodd"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M405.34,135.33c-5.65-3.2-6-4.57-9-6.36-1.95-1.19-8.72-2.17-13.93-6-2.26-1.68-.05,9.09.06,10,.65,2,2.51,3.69,8.16,7.43,1.91,1.27,2.88,2.13,5.17,2.37l2.79.3,3,1.27,3.41-8.5-.17-.11Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M458.8,102.64c2.74,6.08,7.35,13.68,11.41,20.37,6.38,8.29,8.87,10.23,13.22,8.43,3.75-1.69,4-4,2.58-7.74-3.82-10.13-7.71-22.37-13.23-31.29-3.69-6-8.56-9.71-13.69-7.93C452.13,86.88,456.61,97.76,458.8,102.64Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M458.8,102.64c2.74,6.08,7.35,13.68,11.41,20.37,3.06,3.62,14.47-2.65,11.63-10.65-2.62-7.06-5.5-14.2-9.06-20-3.69-6-8.56-9.71-13.69-7.93C452.13,86.88,456.61,97.76,458.8,102.64Z",
    transform: "translate(0 -13)",
    fill: "#b1ddce",
    fillRule: "evenodd"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M470.37,121.42l-21.35.25c-1.37,5-1.11,6.75-.64,11.68,2.91.41,25,1.49,33.9.3,4.07-.55,4.73-2.27,4.44-6.31C486.18,120.06,477.41,121.37,470.37,121.42Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M468.23,86a19.25,19.25,0,0,1,5.35,7.59c7.63,17.13,3.82,38.86,6.47,56.87a32.68,32.68,0,0,0,.84,5.33c.93,12.62-32.24,20.06-38.84,17.71-5.77-6.79-12.38-46.83-12.77-58.21-.22-6.2,1.28-10.42,5.2-15.55A39.3,39.3,0,0,1,442.41,92C448.37,87.57,461.11,80.48,468.23,86Z",
    transform: "translate(0 -13)",
    fill: "#c7e7dc",
    fillRule: "evenodd"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M430,109.32c-1.95,10-1,21.65-2.44,32.63-1,9.38-3.11,14.12,4.77,15.76,4.22,1.11,5.55-.31,6.92-4.39l7.08-30.57c3-14.43-.95-16.76-6.17-18.43C435.14,102.73,430.68,105.57,430,109.32Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M429.79,109.32c-1.18,6.05-1.94,18.08-2.17,24.8,2.24,4.32,14.1,8,16.45,3.5l2.61-14.87c3-14.43-1.35-16.76-6.57-18.43C435.14,102.73,430.52,105.57,429.79,109.32Z",
    transform: "translate(0 -13)",
    fill: "#d5ece4",
    fillRule: "evenodd"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M424.51,141.15l-22.41-7.66c-3.05,2.9-3.47,5-3.46,9.53,2.72,1.53,23.62,12.56,32.9,14.83,4.24,1,5.55-.41,6.84-4.51C439.79,148.65,437.57,145.42,424.51,141.15Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M402,133.75c-.84-1.78-1.39-3.79-2-5.37-.94-2.33-2.58-2.79-4.09-3.72-.93-.58-6-3.7-6.41-3.65-1.22,1.72.33,4.56,3.55,6l1.91,2.83Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M434.27,61c-3.9,3.24-3.12,6.54-1.21,15.84.27,5.74.45,11.78,3,14.23,1.84,1.75,5.63.51,7.42-.75,0,2.12.54,4.32.52,6.44,4.49,2.14,12.72.9,14.75-3.1-1.56-7.1-2.36-8.47-2.38-12,0-5.55,1.57-12.41-.14-17.8-.9-2.84-3-5-7.87-6.3A16.07,16.07,0,0,0,434.27,61Z",
    transform: "translate(0 -13)",
    fill: "#f0a884",
    fillRule: "evenodd"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M441.18,81.39c.79,2.72,1.06,4.91.15,6.07-.69.88-2.27,1.45-3.68-.47s-.93-3.47-4.22-5.1c0,.66.05,1.36.08,2,.77.83,2.15,2.23,2.07,3.22-.1,1.28-1.05.07-1.35-.29.34,4.29,2,9.06,2.77,9.17,2.51.38,7.68-6.31,7.71-7.71C444.77,86,442.82,83.51,441.18,81.39Z",
    transform: "translate(0 -13)",
    fill: "#e5e5e4",
    fillRule: "evenodd"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M432.73,69.74a9.71,9.71,0,0,1-2-7.35c1.42-5.85,9.52-8.49,16-8.12,7.14.4,11,3.47,12.62,8.26,1.9,5.61-.33,13.44-2.69,19.56-1.64,4.27-4,4.09-7.14,2.9a10,10,0,0,1-4.05-2.7c-3-3.3-2.91-5.22-7.09-8.32l-.4,2c-.44,2.16-1.33,1.83-1.8-.2-.36-1.55,0-1.88-.26-3.68C435.7,70.78,435,70,432.73,69.74Z",
    transform: "translate(0 -13)",
    fill: "#e5e5e4",
    fillRule: "evenodd"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M443.39,91.68c.15,1.61.64,3.44.62,5,2.89,3.08,13.38,1.27,14.75-3.1-.74-3.35-.65-6.83-1-8.46C456,89.92,447.06,93.63,443.39,91.68Z",
    transform: "translate(0 -13)",
    fill: "#d5ece4",
    fillRule: "evenodd"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M405.34,134.6c-.1-.86-2.78-2.12-3.31-1.61-3.39,1.12-4.68,6.7-2.92,10.47.59.64,3.3,2.78,3.95,1.92C402,143.4,401.86,136.05,405.34,134.6Z",
    transform: "translate(0 -13)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M400.68,136.21a2.2,2.2,0,0,0-2.3,1.92,2,2,0,0,0,1.42,2.52,2.22,2.22,0,0,0,2.31-1.93,2,2,0,0,0-1.43-2.51",
    transform: "translate(0 -13)",
    fill: "#fff",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M405.34,134.6a.83.83,0,0,0-.28-.49c-3.66,1.57-3.58,9-2.54,11.47a.59.59,0,0,0,.54-.2C402,143.4,401.86,136.05,405.34,134.6Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 271.15,
    y1: 9.42,
    x2: 232.84,
    y2: 47.73,
    fill: "#fff",
    stroke: "#ee6767",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M304.18,30.2a6,6,0,0,1-2,4.35,7.17,7.17,0,0,1-4.85,1.59,6.45,6.45,0,0,1-5.19-2.22,9.1,9.1,0,0,1-1.89-6.09v-1a10.3,10.3,0,0,1,.87-4.35,6.61,6.61,0,0,1,2.49-2.89,7.82,7.82,0,0,1,8.54.58,6.48,6.48,0,0,1,2.09,4.46h-3.53a3.54,3.54,0,0,0-.92-2.4,3.42,3.42,0,0,0-2.42-.75,3,3,0,0,0-2.64,1.27,7.15,7.15,0,0,0-.9,3.92v1.29a7.59,7.59,0,0,0,.84,4.06,2.94,2.94,0,0,0,2.66,1.28,3.48,3.48,0,0,0,2.44-.74,3.42,3.42,0,0,0,.92-2.31Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M313.65,35.9a3.58,3.58,0,0,1-.34-1.14,4.1,4.1,0,0,1-3.21,1.38,4.48,4.48,0,0,1-3.1-1.09,3.47,3.47,0,0,1-1.23-2.72,3.6,3.6,0,0,1,1.5-3.11,7.34,7.34,0,0,1,4.33-1.09h1.57V27.4a2.14,2.14,0,0,0-.45-1.42,1.81,1.81,0,0,0-1.43-.53,2,2,0,0,0-1.35.42,1.38,1.38,0,0,0-.49,1.13h-3.4a3.45,3.45,0,0,1,.68-2.05,4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.53,5.55,5.55,0,0,1,3.74,1.18,4.13,4.13,0,0,1,1.38,3.32V33a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.36a2.89,2.89,0,0,0,1.39-.34,2.16,2.16,0,0,0,.94-.9V30.11H311.9c-1.7,0-2.61.59-2.72,1.77v.2a1.38,1.38,0,0,0,.45,1.05A1.73,1.73,0,0,0,310.84,33.54Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M322.32,23.17l.11,1.47a4.46,4.46,0,0,1,3.66-1.7,3.69,3.69,0,0,1,3,1.18,5.53,5.53,0,0,1,1,3.56V35.9h-3.4V27.76a2.23,2.23,0,0,0-.47-1.57,2.08,2.08,0,0,0-1.56-.49,2.35,2.35,0,0,0-2.16,1.23v9h-3.4V23.17Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M332.25,24l-1.6-.93a6.2,6.2,0,0,0,1.05-3.28v-2h2.71v1.82a5.44,5.44,0,0,1-.59,2.3A6.28,6.28,0,0,1,332.25,24Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M340.88,20v3.13h2.17v2.5h-2.17V32a1.51,1.51,0,0,0,.27,1,1.32,1.32,0,0,0,1,.31,5,5,0,0,0,1-.09v2.58a6.77,6.77,0,0,1-2.06.31c-2.38,0-3.6-1.21-3.64-3.61V25.67h-1.86v-2.5h1.86V20Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M356.24,33.4a2.25,2.25,0,0,0,1.53-.52,1.82,1.82,0,0,0,.61-1.38h3.19a4.32,4.32,0,0,1-.7,2.37,4.67,4.67,0,0,1-1.9,1.67,6,6,0,0,1-2.67.6A5.5,5.5,0,0,1,352,34.4a6.82,6.82,0,0,1-1.58-4.79v-.23A6.79,6.79,0,0,1,352,24.69a5.48,5.48,0,0,1,4.3-1.75,5.34,5.34,0,0,1,3.83,1.36,4.77,4.77,0,0,1,1.46,3.61h-3.19a2.31,2.31,0,0,0-.61-1.61,2,2,0,0,0-1.55-.62,2.05,2.05,0,0,0-1.79.86,5,5,0,0,0-.61,2.81v.36a5.11,5.11,0,0,0,.6,2.83A2.08,2.08,0,0,0,356.24,33.4Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M370.89,35.9a3.58,3.58,0,0,1-.34-1.14,4.1,4.1,0,0,1-3.21,1.38,4.48,4.48,0,0,1-3.1-1.09A3.47,3.47,0,0,1,363,32.33a3.6,3.6,0,0,1,1.5-3.11,7.34,7.34,0,0,1,4.33-1.09h1.57V27.4A2.14,2.14,0,0,0,370,26a1.81,1.81,0,0,0-1.43-.53,2,2,0,0,0-1.35.42,1.38,1.38,0,0,0-.49,1.13h-3.4A3.45,3.45,0,0,1,364,25a4.56,4.56,0,0,1,1.93-1.48,7,7,0,0,1,2.8-.53,5.55,5.55,0,0,1,3.74,1.18,4.13,4.13,0,0,1,1.38,3.32V33a6.09,6.09,0,0,0,.51,2.74v.2Zm-2.81-2.36a2.89,2.89,0,0,0,1.39-.34,2.21,2.21,0,0,0,.94-.9V30.11h-1.27c-1.7,0-2.61.59-2.72,1.77v.2a1.38,1.38,0,0,0,.45,1.05A1.73,1.73,0,0,0,368.08,33.54Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89,29.65a7.64,7.64,0,0,1-1.33,4.72A4.29,4.29,0,0,1,383,36.14a4,4,0,0,1-3.12-1.34v6h-3.4V23.17h3.16l.11,1.25a4,4,0,0,1,3.23-1.48,4.31,4.31,0,0,1,3.66,1.74,7.84,7.84,0,0,1,1.3,4.8Zm-3.4-.24a5,5,0,0,0-.63-2.74,2,2,0,0,0-1.83-1,2.23,2.23,0,0,0-2.2,1.23v5.21a2.27,2.27,0,0,0,2.23,1.26Q384.49,33.4,384.49,29.41Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M394.07,20v3.13h2.18v2.5h-2.18V32a1.51,1.51,0,0,0,.27,1,1.35,1.35,0,0,0,1,.31,5,5,0,0,0,1-.09v2.58a6.86,6.86,0,0,1-2.06.31c-2.39,0-3.6-1.21-3.65-3.61V25.67h-1.86v-2.5h1.86V20Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M405.76,34.61a4.25,4.25,0,0,1-3.48,1.53A4,4,0,0,1,399.16,35a5,5,0,0,1-1.1-3.45V23.17h3.4v8.24c0,1.32.6,2,1.81,2a2.45,2.45,0,0,0,2.38-1.21v-9h3.41V35.9h-3.2Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M418.78,26.36a9.62,9.62,0,0,0-1.23-.09,2.49,2.49,0,0,0-2.53,1.3V35.9h-3.4V23.17h3.22l.09,1.52a3.15,3.15,0,0,1,2.84-1.75,3.6,3.6,0,0,1,1.05.15Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M426.05,36.14a6.26,6.26,0,0,1-4.56-1.72,6.13,6.13,0,0,1-1.76-4.58v-.33a7.78,7.78,0,0,1,.74-3.43,5.59,5.59,0,0,1,2.1-2.33,6,6,0,0,1,3.1-.81,5.3,5.3,0,0,1,4.11,1.64,6.7,6.7,0,0,1,1.5,4.67v1.39h-8.1a3.17,3.17,0,0,0,1,2,3,3,0,0,0,2.1.76A3.66,3.66,0,0,0,429.34,32L431,33.84a5.09,5.09,0,0,1-2.07,1.69A6.68,6.68,0,0,1,426.05,36.14Zm-.39-10.46a2.15,2.15,0,0,0-1.64.68,3.57,3.57,0,0,0-.81,2h4.73v-.27a2.51,2.51,0,0,0-.61-1.75A2.17,2.17,0,0,0,425.66,25.68Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M290,58.36a7.45,7.45,0,0,1,1.4-4.72,4.52,4.52,0,0,1,3.76-1.79,4,4,0,0,1,3.26,1.44l.14-1.2h3.08v12.3a5.4,5.4,0,0,1-.76,2.91,4.88,4.88,0,0,1-2.13,1.88,7.57,7.57,0,0,1-3.23.65,7.06,7.06,0,0,1-2.73-.56,4.87,4.87,0,0,1-2-1.44l1.51-2.07a4,4,0,0,0,3.08,1.42,3,3,0,0,0,2.11-.72,2.72,2.72,0,0,0,.75-2v-.69a3.94,3.94,0,0,1-3.1,1.33,4.52,4.52,0,0,1-3.71-1.79A7.49,7.49,0,0,1,290,58.5Zm3.4.25a4.68,4.68,0,0,0,.7,2.72,2.22,2.22,0,0,0,1.91,1,2.36,2.36,0,0,0,2.22-1.17V55.78a2.37,2.37,0,0,0-2.2-1.16,2.23,2.23,0,0,0-1.93,1A5.28,5.28,0,0,0,293.41,58.61Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M311.64,64.82a3.74,3.74,0,0,1-.34-1.14,4.15,4.15,0,0,1-3.21,1.37A4.52,4.52,0,0,1,305,64a3.48,3.48,0,0,1-1.23-2.73,3.61,3.61,0,0,1,1.5-3.11A7.41,7.41,0,0,1,309.59,57h1.57v-.73a2,2,0,0,0-.46-1.41,1.77,1.77,0,0,0-1.42-.53,2,2,0,0,0-1.35.41,1.39,1.39,0,0,0-.49,1.13H304a3.45,3.45,0,0,1,.68-2,4.54,4.54,0,0,1,1.93-1.47,7,7,0,0,1,2.8-.54A5.61,5.61,0,0,1,313.19,53a4.15,4.15,0,0,1,1.38,3.33v5.52a6.28,6.28,0,0,0,.5,2.74v.2Zm-2.81-2.37a3,3,0,0,0,1.39-.33,2.34,2.34,0,0,0,.94-.9V59h-1.27c-1.71,0-2.61.59-2.72,1.76V61a1.37,1.37,0,0,0,.44,1A1.73,1.73,0,0,0,308.83,62.45Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M324.33,55.28a8.19,8.19,0,0,0-1.22-.1,2.49,2.49,0,0,0-2.53,1.31v8.33h-3.4V52.09h3.21l.1,1.51a3.15,3.15,0,0,1,2.83-1.75,3.62,3.62,0,0,1,1.06.15Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M325.22,58.36a7.64,7.64,0,0,1,1.33-4.74,4.33,4.33,0,0,1,3.66-1.77,3.9,3.9,0,0,1,3.07,1.39V46.75h3.41V64.82h-3.07l-.17-1.36a4,4,0,0,1-3.27,1.59,4.3,4.3,0,0,1-3.6-1.77A7.88,7.88,0,0,1,325.22,58.36Zm3.4.25a5.11,5.11,0,0,0,.62,2.75,2,2,0,0,0,1.81,1A2.28,2.28,0,0,0,333.28,61V56a2.25,2.25,0,0,0-2.2-1.33Q328.62,54.62,328.62,58.61Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M345.18,65.05a6.26,6.26,0,0,1-4.56-1.72,6.1,6.1,0,0,1-1.76-4.57v-.33a7.62,7.62,0,0,1,.75-3.43,5.35,5.35,0,0,1,2.1-2.33,5.84,5.84,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.11,1.65,6.69,6.69,0,0,1,1.5,4.67v1.39h-8.11a3.13,3.13,0,0,0,1,2,3,3,0,0,0,2.1.75,3.67,3.67,0,0,0,3.07-1.42l1.67,1.87a5.17,5.17,0,0,1-2.07,1.69A6.87,6.87,0,0,1,345.18,65.05Zm-.39-10.46a2.12,2.12,0,0,0-1.64.69,3.57,3.57,0,0,0-.8,2h4.73V57a2.58,2.58,0,0,0-.61-1.76A2.23,2.23,0,0,0,344.79,54.59Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M355.48,52.09l.1,1.47a4.44,4.44,0,0,1,3.66-1.71,3.72,3.72,0,0,1,3,1.19,5.62,5.62,0,0,1,1,3.55v8.23h-3.4V56.68a2.24,2.24,0,0,0-.47-1.58,2.15,2.15,0,0,0-1.57-.48,2.32,2.32,0,0,0-2.15,1.22v9h-3.4V52.09Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M365.82,48.79a1.68,1.68,0,0,1,.51-1.26,1.93,1.93,0,0,1,1.4-.49,1.89,1.89,0,0,1,1.38.49,1.8,1.8,0,0,1,0,2.53,2.17,2.17,0,0,1-2.77,0A1.66,1.66,0,0,1,365.82,48.79Zm3.61,16H366V52.09h3.41Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M375.36,52.09l.11,1.47a4.44,4.44,0,0,1,3.66-1.71,3.7,3.7,0,0,1,3,1.19,5.5,5.5,0,0,1,1,3.55v8.23h-3.4V56.68a2.24,2.24,0,0,0-.47-1.58,2.13,2.13,0,0,0-1.56-.48,2.34,2.34,0,0,0-2.16,1.22v9h-3.4V52.09Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M385.23,58.36a7.45,7.45,0,0,1,1.4-4.72,4.52,4.52,0,0,1,3.76-1.79,4,4,0,0,1,3.26,1.44l.14-1.2h3.08v12.3a5.4,5.4,0,0,1-.76,2.91A4.88,4.88,0,0,1,394,69.18a7.57,7.57,0,0,1-3.23.65,7.06,7.06,0,0,1-2.73-.56,4.81,4.81,0,0,1-2-1.44l1.51-2.07a4,4,0,0,0,3.08,1.42,2.91,2.91,0,0,0,2.1-.72,2.69,2.69,0,0,0,.76-2v-.69a3.94,3.94,0,0,1-3.1,1.33,4.52,4.52,0,0,1-3.71-1.79,7.49,7.49,0,0,1-1.42-4.76Zm3.4.25a4.6,4.6,0,0,0,.7,2.72,2.21,2.21,0,0,0,1.9,1,2.37,2.37,0,0,0,2.23-1.17V55.78a2.37,2.37,0,0,0-2.2-1.16,2.23,2.23,0,0,0-1.93,1A5.28,5.28,0,0,0,388.63,58.61Z",
    transform: "translate(0 -13)",
    fill: "#ee6767"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M101.41,107.26c-2.45-7.06-2.34-14,1.9-18.92S115,84.51,115,84.51h0s4.91-4,11.6.6,4.39,11.2,7.67,15c1.94,2.27,8.24.84,9,10,.22,2.65-2,5.19-4.23,6.09-3.91,1.58-8.11,1-9.25,3.29-3.77,7.43-16.16,9.16-19.25,4.47-1-1.45-10.73,5.1-12.7-6.27C96.89,112,103.6,113.57,101.41,107.26Z",
    transform: "translate(0 -13)",
    fill: "#bababa"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,156.2s22.66-3,29.49-1.53c1.72-5.78,2.11-15.9,2.72-19.83,1.78-11.47,12.78-10.29,11.56,4.62-1.56,19-7.23,24.43-13.64,24.41-5.5.28-29.14-4.8-29.14-4.8Z",
    transform: "translate(0 -13)",
    fill: "#a81d41"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M93.13,194l2.06,11.88,4.48,25.87,6.82,1.3s4.36-12.68,4.7-24.56c.19-6.35-.77-12.47-4.14-16.32l17.73,5.7,8-20.23s-23.8-1.4-35.92,1.14C89.39,180.39,93.13,194,93.13,194Z",
    transform: "translate(0 -13)",
    fill: "#de623c"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41,232a4.08,4.08,0,0,1-4.12-2.45c-2.8,7-13.91,6.48-13.09,13.44a1.24,1.24,0,0,0,1.53,1.05c11.6-3,18.35-4.65,21.22-5.34a1.6,1.6,0,0,0,1.14-2.06,66.71,66.71,0,0,0-2.57-6.63S106.6,232,103.41,232Z",
    transform: "translate(0 -13)",
    fill: "#e62954"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M93.13,194l2.06,11.88c4.48.71,12.76,2,16,2.61.19-6.35-.77-12.47-4.14-16.32l17.73,5.7,8-20.23s-23.8-1.4-35.92,1.14C89.39,180.39,93.13,194,93.13,194Z",
    transform: "translate(0 -13)",
    fill: "#2d2958"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M109.38,241.89a1.62,1.62,0,0,0-1.21-3l-15.91,3.93A1.62,1.62,0,0,0,93,246L109,242.07A1.63,1.63,0,0,0,109.38,241.89Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M129.05,231.81a42.36,42.36,0,0,0,7.85-.68l-1-4.64c-.91.19-22.61,4.36-29.71-11.77-8.1-18.41-19.8-25.13-28.19-27.53l-1.3,4.56c7.41,2.12,17.79,8.15,25.15,24.88,3.61,8.2,10.87,13.3,21,14.76A44,44,0,0,0,129.05,231.81Z",
    transform: "translate(0 -13)",
    fill: "#2da84a"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M118.63,246l.62-4.7c-14.59-1.92-22.9-3.67-24.08-17.12-2.07-23.71-18.32-30.66-19-30.94l-1.8,4.38c.57.25,14.28,6.26,16.09,27C92,242.53,105.55,244.32,118.63,246Z",
    transform: "translate(0 -13)",
    fill: "#2da84a"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M81.89,181c.61-4.24,12.09-13.33,10.44-18.61a4.9,4.9,0,0,0-2.59-3c-5.11-2.48-13.94,1.07-15.17,1.58l.22,3.34c4.16-1.7,10.67-3.41,13.56-2a1.47,1.47,0,0,1,.89,1c.91,4-7.86,9.92-10.17,17.39Z",
    transform: "translate(0 -13)",
    fill: "#030405"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M114.85,253.56a9.93,9.93,0,1,1,9.93,10A10,10,0,0,1,114.85,253.56Zm1.61,0a8.32,8.32,0,1,0,8.32-8.36A8.35,8.35,0,0,0,116.46,253.56Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M48.57,253.56a4.83,4.83,0,1,0,4.83-4.86A4.84,4.84,0,0,0,48.57,253.56Z",
    transform: "translate(0 -13)",
    fill: "#113453"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M173.37,254.7a4.84,4.84,0,1,0,3.55-5.86A4.85,4.85,0,0,0,173.37,254.7Z",
    transform: "translate(0 -13)",
    fill: "#113453"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M145.63,261.43A33.38,33.38,0,1,1,186,286.18,33.51,33.51,0,0,1,145.63,261.43Zm3.92-.95a29.35,29.35,0,1,0,21.56-35.59A29.46,29.46,0,0,0,149.55,260.48Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M20,253.56A33.38,33.38,0,1,1,53.4,287.12,33.5,33.5,0,0,1,20,253.56Zm4,0a29.35,29.35,0,1,0,29.35-29.5A29.47,29.47,0,0,0,24.05,253.56Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M130,242.19a1.63,1.63,0,0,0,1.51,2.2,1.6,1.6,0,0,0,1.5-1l14.19-37.72,29.25,48.43c.28.32,3.18-1.18,2.59-1.86l-30.22-50c.08-.21,2.69-8,2.69-8a1.62,1.62,0,0,0-.93-2.09,1.6,1.6,0,0,0-2.08.94l-2.6,6.9-1.22,3.24h0Z",
    transform: "translate(0 -13)",
    fill: "#2da84a"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M53,255a1.7,1.7,0,0,0,.54.09A1.61,1.61,0,0,0,55,254l19.52-54.13L70.9,200l-1.46,4.14L52,252.93A1.63,1.63,0,0,0,53,255Z",
    transform: "translate(0 -13)",
    fill: "#2da84a"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M140.53,196H156.8a3.24,3.24,0,0,0,0-6.48H140.53a3.24,3.24,0,0,0,0,6.48Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M113.74,252.63c.46,1.89,64.43,2.49,68.42,1.22,0-9.32-58.76-18.37-68-15.17C111.32,239.69,112.9,249.22,113.74,252.63Z",
    transform: "translate(0 -13)",
    fill: "#2da84a"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M114.8,217.46c.42,2,3,8.6,5.42,16.39,2.81,9,5.49,19.43,4.64,26l8.28-2.23c2.6-8,2-18,.65-26A112.39,112.39,0,0,0,130.66,218c-.23-.74-.37-1.15-.37-1.15l-15.13-4.16A15.38,15.38,0,0,0,114.8,217.46Z",
    transform: "translate(0 -13)",
    fill: "#f37b51"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M115.16,212.73l14.49,6,1-.71c18.15-12.94,32.75-31.46,31.44-41H130.89S120,201.55,115.16,212.73Z",
    transform: "translate(0 -13)",
    fill: "#fed2a6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M137.37,268.06a1.62,1.62,0,0,0-1.21-3L120.24,269a1.62,1.62,0,0,0,.78,3.15l15.91-3.93A1.57,1.57,0,0,0,137.37,268.06Z",
    transform: "translate(0 -13)",
    fill: "#082540"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M129.16,258.17c-3.56,0-4.19-2.66-4.19-2.66-2.94,7.33-14.48,7.07-14.54,13.8a1.84,1.84,0,0,0,2.3,1.78C129.8,266.7,137,265,137,265a72.44,72.44,0,0,0-3.34-9S132.63,258.13,129.16,258.17Z",
    transform: "translate(0 -13)",
    fill: "#e62954"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M114.8,217.46c.42,2,3,8.6,5.42,16.39l13.57-2.2A112.39,112.39,0,0,0,130.66,218c18.15-12.94,32.75-31.46,31.44-41H130.89s-10.9,24.5-15.73,35.68A15.38,15.38,0,0,0,114.8,217.46Z",
    transform: "translate(0 -13)",
    fill: "#4a4d80"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M82.23,163.26c-1.92-.33-3.2-3.37-3.69-3.49a1,1,0,0,0-1.15.38c-.26.38-.61.89-1,1.54s-.61,1.1-.48,1.34a3.33,3.33,0,0,1,0,1.27,2.57,2.57,0,0,1-.58,1.54c-.33.39-.56.12-.68-.8s-.3-1.94-.54-3.07c.35-1.08.68-2.05,1-2.91.63-1.65,1.27-2.54,1.9-2.67,5.78-.61,9.3.43,10.83.08.76,3,1.61,4.84.72,5.17S84.16,163.59,82.23,163.26Z",
    transform: "translate(0 -13)",
    fill: "#f37b51"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M74.79,164.31a3.62,3.62,0,0,0,5,.9,3.67,3.67,0,0,0,.89-5.07,3.62,3.62,0,0,0-5-.9A3.66,3.66,0,0,0,74.79,164.31Z",
    transform: "translate(0 -13)",
    fill: "#737a78"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.74 187.42 74.22 187.73 82.5 167.99 78.22 167.61 70.74 187.42",
    fill: "#2da84a"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.36 97.9 129.65 108.73 118.18 114.78 116.82 104.04 126.36 97.9",
    fill: "#f37b51"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09,177.05c-2.21-10.5-10.78-13.89-13.43-22.33-4.33-13.83-5.22-30.83-19-33.63l-12.34,6.13c.48,2.36-.06,9.07-.61,14.34A23.62,23.62,0,0,0,119.3,155l11.58,22.06Z",
    transform: "translate(0 -13)",
    fill: "#e62954"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M87.28,156.2s28.55,2,30.25,1.27c1.93-6.38,1.72-17.25,1.72-21.64,0-12.49,15.47-11.5,14,4.94-1.89,20.91-8.12,26.92-15.11,26.85-6,.27-31.4-4.88-31.4-4.88Z",
    transform: "translate(0 -13)",
    fill: "#c51f4b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.24,
    cy: 163.74,
    r: 4.27,
    fill: "#3f974f"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M69.86,178.77a4.28,4.28,0,1,0,4.28-4.27A4.28,4.28,0,0,0,69.86,178.77Z",
    transform: "translate(0 -13)",
    fill: "#3f974f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.71,
    cy: 165.88,
    r: 4.27,
    fill: "#3f974f"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M47.49,177.25A3.25,3.25,0,1,0,50.74,174,3.25,3.25,0,0,0,47.49,177.25Z",
    transform: "translate(0 -13)",
    fill: "#3f974f"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M63.62,177.62a4.28,4.28,0,1,0,4.27-4.28A4.27,4.27,0,0,0,63.62,177.62Z",
    transform: "translate(0 -13)",
    fill: "#3f974f"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M60.07,173.34a3.12,3.12,0,1,0,3.12-3.12A3.12,3.12,0,0,0,60.07,173.34Z",
    transform: "translate(0 -13)",
    fill: "#3f974f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.75,
    cy: 165.88,
    r: 4.39,
    fill: "#3f974f"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M55.74,175.86a3.14,3.14,0,1,0,3.14-3.14A3.13,3.13,0,0,0,55.74,175.86Z",
    transform: "translate(0 -13)",
    fill: "#3f974f"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.53 188.48 70.56 188.48 78.27 167.54 49.69 167.35 53.53 188.48",
    fill: "#fff"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2,171.33c0,2.92,3,5.28,3,5.28s3-2.36,3-5.28-3-5.28-3-5.28S56.2,168.42,56.2,171.33Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M53.24,175.43c2.21,1.9,6,1.18,6,1.18s.18-3.82-2-5.72-6-1.19-6-1.19S51,173.52,53.24,175.43Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M74,175.12c-1.56,1.18-1.62,3.74-1.62,3.74s2.48.66,4-.52,1.61-3.75,1.61-3.75S75.58,173.94,74,175.12Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M70.63,175.19c-.13,1.95,1.77,3.67,1.77,3.67s2.12-1.45,2.25-3.4-1.77-3.67-1.77-3.67S70.76,173.24,70.63,175.19Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.01 174.82 72.69 174.82 72.69 173.63 50.78 173.63 51.01 174.82",
    fill: "#3f974f"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.18 181.29 69.76 181.29 69.76 180.11 51.99 180.11 52.18 181.29",
    fill: "#3f974f"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M128.06,104.64c0,8.88-5.67,16.07-12.64,16.06s-12.62-7.2-12.61-16.08,5.67-16.07,12.64-16.06S128.06,95.77,128.06,104.64Z",
    transform: "translate(0 -13)",
    fill: "#f37b51"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8,108.47a12.66,12.66,0,0,1-1.42,2.18.48.48,0,0,0,0,.66,6.53,6.53,0,0,0,3.33,1.31.13.13,0,0,0,.08-.24,6.23,6.23,0,0,1-1.86-1.34.58.58,0,0,1-.11-.51c.09-.41.28-1.24.39-1.92A.22.22,0,0,0,107.8,108.47Z",
    transform: "translate(0 -13)",
    fill: "#de623c"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M110.65,106.68c-.23-1.5,1.39-2.94,3.69-3.3a6.55,6.55,0,0,1,1-.07c1.89,0,3.34.86,3.53,2.1.23,1.5-1.39,2.94-3.69,3.3a6.33,6.33,0,0,1-1,.07C112.3,108.78,110.84,107.92,110.65,106.68Zm3.8-2.59c-1.84.28-3.25,1.42-3.09,2.48.13.87,1.32,1.5,2.83,1.5a5.07,5.07,0,0,0,.86-.07c1.84-.28,3.26-1.42,3.1-2.48-.14-.87-1.33-1.5-2.83-1.5A6.38,6.38,0,0,0,114.45,104.09Z",
    transform: "translate(0 -13)",
    fill: "#2d2958"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M104.61,108.69c-2-.17-3.57-1.49-3.44-2.93s1.59-2.33,3.44-2.33l.45,0c2,.17,3.57,1.49,3.45,2.93s-1.6,2.33-3.45,2.33Zm-2.73-2.87c-.09,1,1.19,2,2.8,2.16h.38c1.48,0,2.65-.72,2.74-1.67s-1.2-2-2.8-2.16h-.39C103.14,104.15,102,104.86,101.88,105.82Z",
    transform: "translate(0 -13)",
    fill: "#2d2958"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.28,
    y: 105.05,
    width: 0.72,
    height: 2.72,
    transform: "translate(-4.94 194.49) rotate(-85.56)",
    fill: "#2d2958"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118.39,
    y: 104.22,
    width: 8.57,
    height: 0.72,
    transform: "translate(-14.13 6.31) rotate(-8.51)",
    fill: "#2d2958"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M128,103.86c-8.12.83-21-4.57-22.93-8.47.34-5.3,7.86-9.72,13-8.53S129.89,96.85,128,103.86Z",
    transform: "translate(0 -13)",
    fill: "#bababa"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M125.26,104.23c-1.54,1.93-1.52,4.51.06,5.77s4.09.72,5.63-1.2,1.52-4.5-.06-5.76S126.8,102.31,125.26,104.23Z",
    transform: "translate(0 -13)",
    fill: "#f37b51"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M127.53,109a.65.65,0,0,1-.22-.11,2.44,2.44,0,0,1-.88-2.86,2.59,2.59,0,0,1,2.54-1.61.53.53,0,0,1,.49.58.54.54,0,0,1-.58.49,1.53,1.53,0,0,0-1.45.94,1.38,1.38,0,0,0,.57,1.63.53.53,0,0,1,.07.75A.55.55,0,0,1,127.53,109Z",
    transform: "translate(0 -13)",
    fill: "#de623c"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M169.35,276.14c20.74,8.26,39.39-16.47,25.72-34.12C204.81,260.19,189.49,280.5,169.35,276.14Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M171.78,268.93c13.79,6.31,27.12-11.28,17.22-22.85A15.84,15.84,0,0,1,171.78,268.93Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M53.05,276.08c22.26,1.64,32.6-27.55,14.25-40.28C82.06,250.2,73.56,274.18,53.05,276.08Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2,268.48c15,1.86,22.46-18.92,9.54-27A15.85,15.85,0,0,1,53.2,268.48Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M88.05,163a3.62,3.62,0,0,1-2.2.12c-1.65-1.76-1-5.13.45-6.54.26-.36,2.54-.53,2.81-.17C87.1,157.58,87.14,161.41,88.05,163Z",
    transform: "translate(0 -13)",
    fill: "#5c5c5c"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M89.11,156.41a.92.92,0,0,0-.56-.18c-1.84,1.37-1.85,5.21-1,6.93a1.27,1.27,0,0,0,.52-.16C87.14,161.41,87.1,157.58,89.11,156.41Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.28,158.06a1.14,1.14,0,0,0-1.17.92.92.92,0,0,0,.57,1.24,1.12,1.12,0,0,0,1.16-.91c.17-.61-.08-1.16-.56-1.25",
    transform: "translate(0 -13)",
    fill: "#fff"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 143.32,
    height: 59.71,
    fill: "#ee6767"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.75 56.83 86.41 139.55 66.48 56.83 80.75 56.83",
    fill: "#ee6767"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 28.57,
    r: 24.96,
    fill: "none",
    stroke: "#ee6767",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M28.61,37.63H23.36V51.9H19.83V37.63H14.65V34.77h14Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M36.78,42.36a9.6,9.6,0,0,0-1.22-.09A2.49,2.49,0,0,0,33,43.57V51.9h-3.4V39.17h3.21l.1,1.52a3.13,3.13,0,0,1,2.83-1.75,3.62,3.62,0,0,1,1.06.15Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M44.06,52.14a6.22,6.22,0,0,1-4.56-1.72,6.06,6.06,0,0,1-1.76-4.57v-.33a7.59,7.59,0,0,1,.74-3.43,5.35,5.35,0,0,1,2.1-2.33,5.84,5.84,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.11,1.65,6.67,6.67,0,0,1,1.5,4.67v1.39H41.18a3.2,3.2,0,0,0,1,2,3,3,0,0,0,2.1.75A3.67,3.67,0,0,0,47.35,48L49,49.85A5.07,5.07,0,0,1,47,51.53,6.71,6.71,0,0,1,44.06,52.14Zm-.39-10.46a2.11,2.11,0,0,0-1.64.69,3.54,3.54,0,0,0-.81,2H46v-.27a2.56,2.56,0,0,0-.61-1.76A2.2,2.2,0,0,0,43.67,41.68Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6,51.9a3.58,3.58,0,0,1-.34-1.14,4.13,4.13,0,0,1-3.21,1.38,4.55,4.55,0,0,1-3.11-1.08,3.5,3.5,0,0,1-1.22-2.73,3.6,3.6,0,0,1,1.5-3.11,7.41,7.41,0,0,1,4.33-1.09h1.57V43.4A2.1,2.1,0,0,0,57.66,42a1.76,1.76,0,0,0-1.43-.53,2,2,0,0,0-1.34.41A1.38,1.38,0,0,0,54.4,43H51a3.45,3.45,0,0,1,.68-2,4.5,4.5,0,0,1,1.93-1.48,7.13,7.13,0,0,1,2.8-.53,5.57,5.57,0,0,1,3.74,1.18,4.15,4.15,0,0,1,1.38,3.33V49A6.08,6.08,0,0,0,62,51.7v.2Zm-2.81-2.36a2.82,2.82,0,0,0,1.38-.34,2.18,2.18,0,0,0,.95-.9V46.12H56.85c-1.71,0-2.61.58-2.72,1.76v.2a1.37,1.37,0,0,0,.44,1.05A1.77,1.77,0,0,0,55.79,49.54Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M63.61,45.45A7.7,7.7,0,0,1,65,40.7a4.33,4.33,0,0,1,3.65-1.76,3.89,3.89,0,0,1,3.07,1.39v-6.5h3.41V51.9H72l-.16-1.35a4,4,0,0,1-3.27,1.59A4.33,4.33,0,0,1,65,50.37,7.88,7.88,0,0,1,63.61,45.45Zm3.4.25a5.05,5.05,0,0,0,.62,2.74,2,2,0,0,0,1.82,1,2.28,2.28,0,0,0,2.22-1.33V43a2.25,2.25,0,0,0-2.2-1.34C67.83,41.7,67,43,67,45.7Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M80.91,39.17,81,40.6a4.46,4.46,0,0,1,3.66-1.66,3.4,3.4,0,0,1,3.38,1.94,4.37,4.37,0,0,1,3.82-1.94A3.8,3.8,0,0,1,95,40.14a5.53,5.53,0,0,1,1,3.63V51.9H92.55V43.79a2.46,2.46,0,0,0-.42-1.59,1.88,1.88,0,0,0-1.49-.5,2.13,2.13,0,0,0-2.12,1.46V51.9h-3.4V43.8a2.39,2.39,0,0,0-.44-1.6,1.89,1.89,0,0,0-1.48-.5,2.2,2.2,0,0,0-2.09,1.2v9h-3.4V39.17Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M98.55,35.88a1.65,1.65,0,0,1,.52-1.26,1.9,1.9,0,0,1,1.39-.49,1.94,1.94,0,0,1,1.39.49,1.69,1.69,0,0,1,.52,1.26,1.67,1.67,0,0,1-.53,1.27,2.19,2.19,0,0,1-2.76,0A1.67,1.67,0,0,1,98.55,35.88Zm3.62,16H98.75V39.17h3.42Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M108.55,51.9h-3.41V33.83h3.41Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M114.94,51.9h-3.41V33.83h3.41Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M120.52,46.66a7,7,0,0,1,.4-2.63,5.31,5.31,0,0,1,1.47-1.92,7.65,7.65,0,0,0,1.41-1.55,2.35,2.35,0,0,0,.36-1.25c0-1.33-.62-2-1.84-2a1.84,1.84,0,0,0-1.39.53,2.08,2.08,0,0,0-.55,1.48H117a4.53,4.53,0,0,1,1.45-3.52,6.71,6.71,0,0,1,7.77-.06,4.27,4.27,0,0,1,1.38,3.4,4.18,4.18,0,0,1-.45,1.9,7.92,7.92,0,0,1-1.56,2l-1,.91a3.26,3.26,0,0,0-1,2l0,.72Zm-.34,3.6a1.73,1.73,0,0,1,.53-1.29,2.11,2.11,0,0,1,2.75,0,1.73,1.73,0,0,1,.53,1.29,1.68,1.68,0,0,1-.52,1.28,2.14,2.14,0,0,1-2.77,0A1.68,1.68,0,0,1,120.18,50.26Z",
    transform: "translate(0 -13)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFigureMotiv1);
export default __webpack_public_path__ + "static/media/web-figure-motiv-1.5efe5e3c93534a79b633598f7c0b599b.svg";
export { ForwardRef as ReactComponent };